// EquipeAgentsIAPage.jsx
// Page LICORNE — Équipe Experts IA AbracadaWorld
// HERO IDENTIQUE à Super Assistant — même CSS, même layout, même couleurs
// Route: /pro/equipe-agents-ia

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import UnifiedHeader from '../../components/layout/UnifiedHeader';
import EspaceProNav from '../../components/layout/EspaceProNav';
import EspaceProSectionsNav, { EspaceProSectionsNavSpacer } from '../../components/layout/EspaceProSectionsNav';
import ImmersiveEspaceProWrapper from '../../components/layout/ImmersiveEspaceProWrapper';

// ══════════════════════════════════════════════════════════════════════════════
// COULEURS — IDENTIQUES À SUPER ASSISTANT
// ══════════════════════════════════════════════════════════════════════════════
const C = {
  navy: '#1E3A5F',
  navyDark: '#1a2a4a',
  navyLight: '#2d5a8a',
  orange: '#F97316',
  orangeDark: '#E8650A',
  green: '#22c55e',
  cream: '#FFFBF7',
  white: '#FFFFFF',
};

const CALENDLY_URL = 'https://calendly.com/abracadabati/fondateur';

// ══════════════════════════════════════════════════════════════════════════════
// LES 12 EXPERTS IA
// ══════════════════════════════════════════════════════════════════════════════
const EXPERTS = [
  { id: 1, emoji: '🎧', name: 'Le Service Client', pole: 'Pôle Relation Client', poleColor: '#0288d1', desc: 'Accueil, réclamations, suivi dossiers. Tes clients sont chouchoutés 24h/24.', ancre: 'Messagerie, Avis, Support', exempleNom: '"Clara", "L\'Accueil"' },
  { id: 2, emoji: '📈', name: 'Le Commercial', pole: 'Pôle Commercial', poleColor: '#E8650A', desc: 'Prospects, pipeline, devis, relances. Il ne laisse aucun lead s\'échapper.', ancre: 'CRM, Pipeline, Devis', exempleNom: '"Arnaud", "Le Chasseur"' },
  { id: 3, emoji: '📋', name: 'L\'Administratif', pole: 'Pôle Administration', poleColor: '#1565c0', desc: 'Mails, agenda, tâches, comptes-rendus. Ton bras droit qui ne s\'endort jamais.', ancre: 'Mails, Agenda, Tâches', exempleNom: '"Sophie", "La Secrétaire"' },
  { id: 4, emoji: '🏗️', name: 'Le Chef de Chantier', pole: 'Pôle Terrain', poleColor: '#2e7d32', desc: 'Planning, équipes, suivi d\'avancement. Il connaît tous tes chantiers en temps réel.', ancre: 'Chantiers, Planning, Équipes', exempleNom: '"Marco", "Le Boss"' },
  { id: 5, emoji: '🚚', name: 'Le Responsable Logistique', pole: 'Pôle Logistique', poleColor: '#f57f17', desc: 'Stock, commandes, expéditions, retours. La chaîne complète sous contrôle.', ancre: 'Catalogue, Commandes, Livraisons', exempleNom: '"Le Livreur", "Chrono"' },
  { id: 6, emoji: '📱', name: 'Le Community Manager', pole: 'Pôle Marketing', poleColor: '#c62828', desc: 'Publications, réponses clients, engagement. Ta présence en ligne sans effort.', ancre: 'Réseau social, Messages, Avis', exempleNom: '"Léa", "Le CM"' },
  { id: 7, emoji: '📣', name: 'Le Responsable Marketing', pole: 'Pôle Marketing', poleColor: '#c62828', desc: 'Stratégie, campagnes, acquisition. Il réfléchit à ta croissance pendant que tu travailles.', ancre: 'Campagnes, Analytics, Stratégie', exempleNom: '"Le Stratège", "Paul"' },
  { id: 8, emoji: '🎨', name: 'Le Graphiste Monteur Vidéo', pole: 'Pôle Création', poleColor: '#6a1b9a', desc: 'Visuels, réels, stories, supports comm. Ton image pro et ton contenu vidéo géré.', ancre: 'Galerie, Médias, Réseau social', exempleNom: '"Picasso", "Le Créatif"' },
  { id: 9, emoji: '🌐', name: 'Le Webmaster', pole: 'Pôle Création', poleColor: '#6a1b9a', desc: 'Boutique, catalogue, SEO, fiche Google. Ta vitrine toujours optimisée.', ancre: 'Boutique, Catalogue, SEO', exempleNom: '"Le Tech", "Digital"' },
  { id: 10, emoji: '🛡️', name: 'Le Modérateur', pole: 'Pôle Réputation', poleColor: '#00695c', desc: 'Avis, commentaires, e-réputation. Il répond avec le bon ton au bon moment.', ancre: 'Avis, Réseau social, Messagerie', exempleNom: '"Le Gardien", "Rep+"' },
  { id: 11, emoji: '📊', name: 'L\'Analyste Financier', pole: 'Pôle Administration', poleColor: '#1565c0', desc: 'Rentabilité, marges, trésorerie, facturation. Il surveille tes chiffres et t\'alerte.', ancre: 'Factures, Rentabilité, Reporting', exempleNom: '"Max", "Le Comptable"' },
  { id: 12, emoji: '⚖️', name: 'Le Conseil Juridique', pole: 'Pôle Juridique', poleColor: '#283593', desc: 'Contrats, CGV, clauses, mentions légales. Tu signes en connaissance de cause.', ancre: 'Contrats, Devis, Documents', exempleNom: '"Maître", "L\'Avocat"' },
];

// ══════════════════════════════════════════════════════════════════════════════
// CONVERSATIONS MOCKUP (pour le téléphone)
// ══════════════════════════════════════════════════════════════════════════════
const CONVERSATIONS = [
  { user: "Fais-moi un devis pour M. Dupont, rénovation salle de bain, environ 4 500€", bot: "Devis créé ✓ Envoyé par email et SMS. Je te notifie quand il répond.", botLabel: "LE COMMERCIAL" },
  { user: "Publie une photo du chantier terminé chez les Martin", bot: "Photo publiée sur AbracadaBati, Facebook et Instagram avec légende ✓", botLabel: "LE COMMUNITY MANAGER" },
];

// ══════════════════════════════════════════════════════════════════════════════
// DONNÉES HERO (identique à Boutique)
// ══════════════════════════════════════════════════════════════════════════════
const HERO_FEATURES = [
  { icon: '🎧', title: 'Service Client', desc: 'Répond à tes clients 24h/24, 7j/7.' },
  { icon: '📈', title: 'Commercial', desc: 'Génère des devis, relance les prospects.' },
  { icon: '📋', title: 'Administratif', desc: 'Classe, organise, archive automatiquement.' },
  { icon: '📱', title: 'Community Manager', desc: 'Publie, engage, modère tes réseaux.' },
  { icon: '📊', title: 'Analyste Financier', desc: 'Surveille ta trésorerie, optimise tes coûts.' },
  { icon: '🎨', title: 'Graphiste', desc: 'Crée tes visuels, logos, supports marketing.' },
];

const HERO_STATS = [
  { value: '2', label: 'Portes d\'entrée' },
  { value: '0%', label: 'Commission' },
  { value: '24/24', label: 'Assistant IA' },
  { value: '7', label: 'Jours d\'installation' },
];

// ══════════════════════════════════════════════════════════════════════════════
// BÉNÉFICES (identique à Super Assistant)
// ══════════════════════════════════════════════════════════════════════════════
const BENEFICES_ARTISAN = [
  { emoji: '🏗️', title: 'Tu es sur le chantier', desc: 'Elle répond aux clients, envoie les devis, relance les impayés.' },
  { emoji: '🚗', title: 'Tu es en déplacement', desc: 'Elle gère tes emails, tes messages, tes rendez-vous.' },
  { emoji: '📋', title: 'Tu es en réunion', desc: 'Elle continue de traiter les demandes entrantes sans t\'interrompre.' },
  { emoji: '👨‍👩‍👧', title: 'Tu es en famille', desc: 'Elle prend le relais. Tu profites de tes proches sans culpabiliser.' },
  { emoji: '🏃', title: 'Tu fais du sport', desc: 'Elle gère le quotidien pendant que tu prends soin de toi.' },
  { emoji: '😴', title: 'Tu dors', desc: 'Elle traite les demandes de la nuit. Tu te réveilles avec tout classé.' },
  { emoji: '🏖️', title: 'Tu es en vacances', desc: 'Ton business tourne. Elle gère les urgences et te prévient si c\'est vraiment important.' },
  { emoji: '☕', title: 'Tu es en repos', desc: 'Elle continue de bosser. Même à 23h un dimanche.' },
];

const BENEFICES_PATRON = [
  { emoji: '🧠', title: 'Moins de charge mentale', desc: 'Fini de tout retenir dans ta tête. Il te rappelle ce qu\'il faut faire, quand il faut le faire.' },
  { emoji: '⏰', title: 'Plus de temps gagné', desc: '+3 heures par jour. Devis, factures, relances, réseaux sociaux... Il le fait à ta place.' },
  { emoji: '💰', title: 'Plus de chiffre d\'affaires', desc: '+30% en moyenne. Aucun prospect oublié. Relances automatiques. Visibilité maximale.' },
  { emoji: '🌙', title: 'Des soirées tranquilles', desc: 'Tu rentres chez toi, tu sais que tout est géré. Tu peux souffler.' },
  { emoji: '❤️', title: 'Du temps pour ce qui compte', desc: 'Ta famille, tes amis, tes passions. Ce pour quoi tu as créé ta boîte.' },
  { emoji: '🎯', title: 'Focus sur l\'essentiel', desc: 'Tu sors de l\'opérationnel. Tu pilotes, tu organises, tu planifies. Le reste, tu délègues.' },
];

// ══════════════════════════════════════════════════════════════════════════════
// LES 12 AGENTS (identique à Super Assistant)
// ══════════════════════════════════════════════════════════════════════════════
const AGENTS = [
  { emoji: '🎯', name: 'Commercial', desc: 'Prospects, relances, closing', color: '#3B82F6' },
  { emoji: '🏗️', name: 'Chef de Chantier', desc: 'Planning, équipes, suivi', color: '#F59E0B' },
  { emoji: '💰', name: 'Comptable', desc: 'Factures, devis, trésorerie', color: '#10B981' },
  { emoji: '📣', name: 'Community Manager', desc: 'Réseaux sociaux', color: '#EC4899' },
  { emoji: '🛡️', name: 'Modérateur', desc: 'Réputation, avis', color: '#8B5CF6' },
  { emoji: '🎨', name: 'Graphiste', desc: 'Visuels, supports', color: '#F43F5E' },
  { emoji: '💻', name: 'Webmaster', desc: 'Site web, SEO', color: '#06B6D4' },
  { emoji: '⚖️', name: 'Conseil Juridique', desc: 'Contrats, CGV', color: '#64748B' },
  { emoji: '📊', name: 'Analyste Financier', desc: 'Reporting, marges', color: '#22C55E' },
  { emoji: '🎬', name: 'Monteur Vidéo', desc: 'Clips, contenus', color: '#EF4444' },
  { emoji: '📈', name: 'Marketing', desc: 'Stratégie, acquisition', color: '#6366F1' },
  { emoji: '📞', name: 'Service Client', desc: 'SAV, réclamations', color: '#0EA5E9' },
];

// ══════════════════════════════════════════════════════════════════════════════
// SCÉNARIOS
// ══════════════════════════════════════════════════════════════════════════════
const SCENARIO_1 = {
  title: 'Un prospect voit ton post. 4 experts entrent en jeu. Tu ne touches à rien.',
  steps: [
    { agent: 'LE COMMUNITY MANAGER', text: 'Un particulier commente ton Reel de chantier : "Vous intervenez sur Bordeaux ?" Il détecte l\'intention commerciale et transmet le lead au Commercial.', color: '#c62828' },
    { agent: 'LE COMMERCIAL', text: 'Répond en moins de 2 minutes, qualifie le besoin, envoie un formulaire de devis. Crée automatiquement la fiche prospect dans le CRM.', color: '#E8650A' },
    { agent: 'L\'ADMINISTRATIF', text: 'Planifie la visite dans ton agenda selon tes disponibilités réelles. Envoie la confirmation automatique au prospect.', color: '#1565c0' },
    { agent: 'LE COMMERCIAL', text: 'Génère le devis après ta visite et l\'envoie au prospect. Relance automatiquement à J+3 et J+7 jusqu\'à la signature.', color: '#E8650A' },
  ],
  result: 'Le prospect est devenu client. Tu n\'as fait que la visite. Le reste ? Géré.'
};

const SCENARIO_2 = {
  title: 'Un client demande où en est son chantier. La réponse arrive en 30 secondes.',
  steps: [
    { agent: 'LE COMMUNITY MANAGER', text: 'Reçoit un message : "Bonjour, vous en êtes où sur le chantier rue des Lilas ?" Il identifie le chantier et consulte le Chef de Chantier.', color: '#c62828' },
    { agent: 'LE CHEF DE CHANTIER', text: 'Consulte les données en temps réel : avancement à 60%, reprise le 28 avril. Fin de chantier prévue le 12 mai. Transmet tout au Community Manager.', color: '#2e7d32' },
    { agent: 'LE COMMUNITY MANAGER', text: 'Répond au client : "Bonjour Marie, votre chantier avance bien — nous en sommes à 60% ! Nos équipes reprennent le 28 avril pour une fin prévue le 12 mai. N\'hésitez pas 😊"', color: '#c62828' },
  ],
  result: 'Le client est rassuré. Réponse en 30 secondes. Tu étais sur un autre chantier.'
};

const SCENARIO_3 = {
  title: 'Une facture impayée depuis 30 jours. Cinq experts se coordonnent. Tu n\'as rien à faire.',
  steps: [
    { agent: 'L\'ANALYSTE FINANCIER', text: 'Détecte une facture impayée depuis 30 jours — client Dupont BTP. Alerte l\'Administratif et le Conseil Juridique.', color: '#1565c0' },
    { agent: 'L\'ADMINISTRATIF', text: 'Envoie une relance email — ton professionnel mais ferme. Programme les relances J+5, J+10 avec escalade si pas de réponse.', color: '#1565c0' },
    { agent: 'LE CONSEIL JURIDIQUE', text: 'Prépare une mise en demeure prête à l\'envoi à J+15. Vérifie les clauses du devis signé pour protéger tes droits.', color: '#283593' },
    { agent: 'LE COMMERCIAL', text: 'Met le client en statut "sensible" dans le CRM. Bloque tout nouveau devis sans ton aval.', color: '#E8650A' },
    { agent: 'L\'ANALYSTE FINANCIER', text: 'Ajuste ta trésorerie prévisionnelle. Tu reçois un résumé clair. Zéro surprise.', color: '#1565c0' },
  ],
  result: 'L\'impayé est géré de bout en bout. Tu as reçu un résumé. Zéro heure perdue.'
};

// ══════════════════════════════════════════════════════════════════════════════
// STYLES — COPIE EXACTE DE SUPER ASSISTANT (classes .sa-*)
// ══════════════════════════════════════════════════════════════════════════════
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600;700&display=swap');
    
    .sa-root { font-family: 'DM Sans', sans-serif; color: ${C.navyDark}; }
    .sa-root * { box-sizing: border-box; }
    .sa-section-gradient { color: ${C.white} !important; }
    .sa-section-gradient .sa-hero-text { color: rgba(255,255,255,0.85) !important; }
    .sa-section-gradient .sa-accent { color: ${C.orange} !important; }
    .sa-section-gradient .sa-chat-body, .sa-section-gradient .sa-chat-body * { color: ${C.navyDark}; }
    .sa-section-gradient .sa-msg-bubble-bot { color: ${C.navyDark} !important; }
    
    .sa-section { padding: clamp(64px, 10vw, 120px) clamp(20px, 5vw, 40px); }
    .sa-section-white { background: ${C.white}; }
    .sa-section-cream { background: ${C.cream}; }
    .sa-section-navy { background: ${C.navy}; color: ${C.white}; }
    .sa-section-gradient { background: linear-gradient(135deg, ${C.navy} 0%, ${C.navyLight} 50%, ${C.navy} 100%); color: ${C.white}; }
    
    .sa-container { max-width: 1280px; margin: 0 auto; padding: 0 24px; }
    .sa-container-narrow { max-width: 1000px; margin: 0 auto; padding: 0 24px; }
    .boutique-container { max-width: 1280px; margin: 0 auto; padding: 0 24px; }
    
    .sa-section-head { text-align: center; margin-bottom: 64px; }
    .sa-eyebrow { 
      display: inline-flex; align-items: center; gap: 8px;
      padding: 10px 20px; border-radius: 999px; margin-bottom: 24px;
      font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 14px;
    }
    .sa-eyebrow-orange { background: rgba(249, 115, 22, 0.1); color: ${C.orangeDark}; }
    .sa-eyebrow-light { background: rgba(255,255,255,0.15); color: ${C.white}; border: 1px solid rgba(255,255,255,0.2); }
    .sa-dot { width: 8px; height: 8px; border-radius: 50%; }
    
    .sa-h2 { 
      font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 800;
      font-size: clamp(32px, 5vw, 56px); line-height: 1.1; margin-bottom: 20px;
    }
    .sa-h3 { 
      font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 700;
      font-size: clamp(24px, 3vw, 36px); line-height: 1.2; margin-bottom: 16px;
    }
    .sa-accent { color: ${C.orange}; }
    .sa-lead { 
      font-size: clamp(16px, 2vw, 20px); color: #4a5568; line-height: 1.6; 
      max-width: 680px; margin: 0 auto;
    }
    .sa-lead-light { color: rgba(255,255,255,0.85); }
    
    .sa-btn { 
      display: inline-flex; align-items: center; gap: 8px;
      padding: 16px 32px; border-radius: 14px;
      font-family: 'DM Sans', sans-serif; font-weight: 700; font-size: 16px;
      text-decoration: none; transition: all 0.2s ease; cursor: pointer; border: none;
    }
    .sa-btn-primary { 
      background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeDark} 100%); 
      color: ${C.white}; box-shadow: 0 8px 24px -8px rgba(249,115,22,0.5);
    }
    .sa-btn-primary:hover { transform: scale(1.03); }
    .sa-btn-ghost { background: transparent; border: 1.5px solid rgba(255,255,255,0.5); color: ${C.white}; }
    .sa-btn-ghost:hover { background: rgba(255,255,255,0.1); }
    .sa-btn-white { background: ${C.white}; color: ${C.orangeDark}; }
    .sa-btn-white:hover { transform: scale(1.03); }
    
    .sa-card {
      background: ${C.white}; border: 1px solid #fce4d4; border-radius: 20px;
      padding: 32px; box-shadow: 0 4px 20px rgba(26,42,74,0.06);
      transition: all 0.3s ease;
    }
    .sa-card:hover { box-shadow: 0 12px 40px rgba(26,42,74,0.12); transform: translateY(-4px); }
    
    .sa-stats-inline { display: flex; gap: 48px; justify-content: center; flex-wrap: wrap; }
    .sa-stat-inline { text-align: center; }
    .sa-stat-value { font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 800; font-size: 42px; }
    .sa-stat-label { font-size: 14px; color: rgba(255,255,255,0.7); margin-top: 4px; }
    
    /* Phone mockup — IDENTIQUE à Super Assistant */
    .sa-phone {
      width: 320px; background: ${C.white}; border-radius: 36px;
      box-shadow: 0 30px 80px rgba(0,0,0,0.2); overflow: hidden;
      border: 10px solid #1a1a1a;
    }
    .sa-phone-notch { height: 24px; background: #1a1a1a; border-radius: 0 0 16px 16px; margin: 0 80px; }
    .sa-chat-header {
      background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeDark} 100%);
      padding: 14px 16px; display: flex; align-items: center; gap: 10px;
    }
    .sa-chat-av { width: 40px; height: 40px; border-radius: 10px; background: rgba(255,255,255,0.25); display: flex; align-items: center; justify-content: center; font-size: 20px; }
    .sa-chat-name { font-weight: 700; color: ${C.white}; font-size: 14px; }
    .sa-chat-status { font-size: 11px; color: rgba(255,255,255,0.8); }
    .sa-chat-online { display: flex; align-items: center; gap: 4px; background: rgba(255,255,255,0.2); padding: 4px 8px; border-radius: 999px; font-size: 10px; color: ${C.white}; font-weight: 600; }
    .sa-chat-dot { width: 6px; height: 6px; border-radius: 50%; background: #22c55e; }
    
    .sa-chat-body { padding: 12px; background: #f8f9fa; min-height: 200px; }
    .sa-msg { display: flex; gap: 6px; margin-bottom: 10px; }
    .sa-msg-user { flex-direction: row-reverse; }
    .sa-msg-bubble { padding: 8px 12px; border-radius: 14px; font-size: 12px; line-height: 1.4; max-width: 220px; }
    .sa-msg-bubble-user { background: ${C.navy}; color: ${C.white} !important; border-bottom-right-radius: 4px; }
    .sa-msg-bubble-bot { background: ${C.white}; color: ${C.navyDark}; border-bottom-left-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
    .sa-msg-label { font-size: 9px; font-weight: 700; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.03em; }
    
    .sa-chat-input { display: flex; align-items: center; gap: 6px; padding: 10px; background: ${C.white}; border-top: 1px solid #eee; }
    .sa-chat-input-field { flex: 1; padding: 8px 12px; background: #f4f4f5; border-radius: 999px; font-size: 12px; color: #9ca3af; }
    .sa-chat-input-mic { width: 32px; height: 32px; border-radius: 50%; background: ${C.orange}; border: none; color: ${C.white}; font-size: 14px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
    
    /* Scenario cards */
    .sa-scenario {
      background: ${C.white}; border: 1px solid #fce4d4; border-radius: 20px;
      overflow: hidden;
      display: flex; flex-direction: column; height: 100%;
    }
    .sa-scenario-header {
      background: linear-gradient(135deg, ${C.navy} 0%, ${C.navyDark} 100%);
      padding: 20px 24px; color: ${C.white};
    }
    .sa-scenario-num { 
      display: inline-flex; align-items: center; justify-content: center;
      width: 32px; height: 32px; border-radius: 50%; background: ${C.orange};
      font-weight: 800; font-size: 14px; margin-right: 12px;
    }
    .sa-scenario-body { padding: 24px; flex: 1; }
    .sa-scenario-step { display: flex; gap: 16px; margin-bottom: 20px; position: relative; }
    .sa-scenario-step:last-child { margin-bottom: 0; }
    .sa-scenario-step::before {
      content: ''; position: absolute; left: 15px; top: 32px; bottom: -20px;
      width: 2px; background: #e2e8f0;
    }
    .sa-scenario-step:last-child::before { display: none; }
    .sa-scenario-dot { 
      width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
      font-weight: 700; font-size: 12px; color: ${C.white}; z-index: 1;
    }
    .sa-scenario-result {
      background: rgba(34, 197, 94, 0.1); border-top: 1px solid rgba(34, 197, 94, 0.2);
      padding: 16px 24px; color: ${C.green}; font-weight: 600;
      display: flex; align-items: center; gap: 8px;
      margin-top: auto;
    }
    
    /* Grid scenarios - même hauteur */
    .sa-scenarios-grid { align-items: stretch; }
    
    /* Bénéfices grid */
    .sa-benefits-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
    @media (max-width: 768px) { .sa-benefits-grid { grid-template-columns: 1fr; } }
    .sa-benefits-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
    @media (max-width: 1024px) { .sa-benefits-grid-4 { grid-template-columns: repeat(2, 1fr); } }
    @media (max-width: 640px) { .sa-benefits-grid-4 { grid-template-columns: 1fr; } }
    .sa-benefit {
      display: flex; gap: 16px; padding: 24px; background: ${C.white};
      border: 1px solid #fce4d4; border-radius: 16px;
      transition: all 0.2s ease;
    }
    .sa-benefit:hover { box-shadow: 0 8px 30px rgba(0,0,0,0.08); transform: translateY(-2px); }
    .sa-benefit-icon { width: 56px; height: 56px; border-radius: 14px; background: rgba(249,115,22,0.1); display: flex; align-items: center; justify-content: center; font-size: 28px; flex-shrink: 0; }
    .sa-benefit-title { font-weight: 700; font-size: 17px; color: ${C.navyDark}; margin-bottom: 6px; }
    .sa-benefit-desc { font-size: 14px; color: #64748b; line-height: 1.5; }
    .sa-eyebrow-navy { background: rgba(30, 58, 95, 0.1); color: ${C.navy}; }
    
    /* ═══ RESPONSIVE HERO AGENTS IA V2 ═══ */
    .agents-hero-v2-grid {
      display: grid;
      grid-template-columns: 47% 53%;
      gap: 48px;
      align-items: flex-start;
    }
    @media (max-width: 1280px) {
      .agents-hero-v2-grid {
        grid-template-columns: 1fr !important;
        gap: 48px !important;
      }
      .agents-visual-v2 {
        order: -1 !important;
        min-height: 580px !important;
      }
      .pricing-card-v2 {
        grid-template-columns: 1fr !important;
      }
    }
    @media (max-width: 900px) {
      .agents-visual-v2 {
        min-height: 480px !important;
        transform: scale(0.8);
        transform-origin: center center;
      }
      .benefits-bar-v2 {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
    @media (max-width: 640px) {
      .agents-visual-v2 {
        display: none !important;
      }
      .benefits-bar-v2 {
        grid-template-columns: repeat(2, 1fr) !important;
      }
    }
    
    /* ═══ RESPONSIVE HERO 3-colonnes (identique Boutique) ═══ */
    @media (max-width: 1400px) {
      .hero-phone-col img { 
        max-width: 340px !important; 
      }
    }
    @media (max-width: 1200px) {
      .hero-grid-3 { 
        grid-template-columns: 1fr 1fr !important; 
        gap: 40px !important;
      }
      .hero-features-col { display: none !important; }
      .hero-phone-col { 
        display: flex !important;
        justify-content: center !important;
      }
      .hero-phone-col img { 
        max-width: 300px !important; 
      }
    }
    @media (max-width: 900px) {
      .hero-phone-col img { 
        max-width: 260px !important; 
      }
    }
    @media (max-width: 768px) {
      .hero-grid-3 { 
        grid-template-columns: 1fr !important; 
        text-align: center;
      }
      .hero-phone-col { 
        display: flex !important;
        order: -1;
        margin-bottom: 32px;
      }
      .hero-phone-col img { 
        max-width: 220px !important; 
      }
      .hero-features-col { 
        display: none !important;
      }
      .hero-stats { 
        justify-content: center !important; 
        flex-wrap: wrap;
        gap: 16px;
      }
      .hero-stats > div {
        border-left: none !important;
        padding: 0 12px !important;
      }
    }
    @media (max-width: 480px) {
      .hero-phone-col img { 
        max-width: 180px !important; 
      }
    }
    
    /* Responsive old */
    @media (max-width: 1024px) {
      .sa-hero-grid { grid-template-columns: 1fr !important; text-align: center; }
      .sa-hero-phone { display: none; }
      .sa-stats-inline { justify-content: center !important; }
      .sa-hero-btns { justify-content: center !important; }
    }
    @media (max-width: 768px) {
      .sa-scenarios-grid { grid-template-columns: 1fr !important; }
      .sa-experts-grid { grid-template-columns: 1fr !important; }
      .sa-metrics-grid { grid-template-columns: repeat(2, 1fr) !important; }
      .sa-before-after { flex-direction: column !important; }
    }
    
    /* ═══ RESPONSIVE BLOC CONCEPT ═══ */
    .concept-cards-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
    }
    @media (max-width: 1024px) {
      .concept-cards-grid {
        grid-template-columns: 1fr !important;
        gap: 20px !important;
      }
      .concept-cards-grid > div {
        transform: none !important;
      }
    }
    .concept-mini-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
    }
    @media (max-width: 900px) {
      .concept-mini-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 16px !important;
      }
    }
    @media (max-width: 500px) {
      .concept-mini-grid {
        grid-template-columns: 1fr !important;
      }
    }
    
    /* ═══ RESPONSIVE BLOC 3 — CE QUE TU GAGNES ═══ */
    .kpi-cards-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
    }
    @media (max-width: 1024px) {
      .kpi-cards-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 16px !important;
      }
    }
    @media (max-width: 500px) {
      .kpi-cards-grid {
        grid-template-columns: 1fr !important;
      }
    }
    .benefits-grid-2col {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 22px;
    }
    @media (max-width: 768px) {
      .benefits-grid-2col {
        grid-template-columns: 1fr !important;
        gap: 16px !important;
      }
    }
    .ia-card-grid {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 40px;
      align-items: center;
    }
    @media (max-width: 900px) {
      .ia-card-grid {
        grid-template-columns: 1fr !important;
        gap: 32px !important;
      }
      .ia-capsules {
        flex-direction: row !important;
        flex-wrap: wrap;
        justify-content: center;
        gap: 12px !important;
      }
      .ia-capsules > div {
        flex: 1 1 auto;
        min-width: 120px;
      }
    }
    @media (max-width: 500px) {
      .ia-capsules {
        flex-direction: column !important;
      }
      .ia-capsules > div {
        min-width: auto;
      }
    }
    
    /* ═══ RESPONSIVE BLOC 4 — DÉMONSTRATION ═══ */
    .demo-layout-grid {
      display: grid;
      grid-template-columns: 45% 55%;
      gap: 32px;
    }
    @media (max-width: 1024px) {
      .demo-layout-grid {
        grid-template-columns: 1fr !important;
        gap: 40px !important;
      }
    }
    .demo-bottom-banner {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    @media (max-width: 768px) {
      .demo-bottom-banner {
        flex-direction: column !important;
        text-align: center;
        gap: 24px !important;
      }
      .demo-pillars {
        justify-content: center !important;
      }
    }
    
    /* ═══ RESPONSIVE BLOC 5 — AGENTS IA ═══ */
    .progression-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
    }
    @media (max-width: 1024px) {
      .progression-grid {
        grid-template-columns: 1fr !important;
        gap: 32px !important;
      }
      .progression-grid > div {
        transform: none !important;
      }
    }
    .agents-grid-12 {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
    }
    @media (max-width: 1100px) {
      .agents-grid-12 {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
    @media (max-width: 768px) {
      .agents-grid-12 {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 16px !important;
      }
    }
    @media (max-width: 500px) {
      .agents-grid-12 {
        grid-template-columns: 1fr !important;
      }
    }
    .ia-mission-grid {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 48px;
      align-items: center;
    }
    @media (max-width: 900px) {
      .ia-mission-grid {
        grid-template-columns: 1fr !important;
        gap: 32px !important;
        text-align: center;
      }
      .mission-capsules {
        align-items: center !important;
      }
    }
    
    /* ═══ RESPONSIVE BLOC 6 — COCKPIT CENTRALISÉ ═══ */
    .cockpit-layout-grid {
      display: grid;
      grid-template-columns: 58% 42%;
      gap: 36px;
      align-items: center;
    }
    @media (max-width: 1100px) {
      .cockpit-layout-grid {
        grid-template-columns: 1fr !important;
        gap: 40px !important;
      }
    }
    .cockpit-modules-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 14px;
    }
    @media (max-width: 700px) {
      .cockpit-modules-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 12px !important;
      }
    }
    .cockpit-bottom-banner {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    @media (max-width: 800px) {
      .cockpit-bottom-banner {
        flex-direction: column !important;
        text-align: center;
        gap: 24px !important;
      }
      .cockpit-pillars {
        justify-content: center !important;
      }
    }
    
    /* ═══ RESPONSIVE BLOC 7 — COMPARAISON ═══ */
    .comparison-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 32px;
    }
    @media (max-width: 900px) {
      .comparison-grid {
        grid-template-columns: 1fr !important;
        gap: 24px !important;
      }
    }
    .difference-cards-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 18px;
    }
    @media (max-width: 900px) {
      .difference-cards-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 16px !important;
      }
    }
    @media (max-width: 500px) {
      .difference-cards-grid {
        grid-template-columns: 1fr !important;
      }
    }
    
    /* ═══ RESPONSIVE BLOC 8 — FORMULES ═══ */
    .launch-banner {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    @media (max-width: 700px) {
      .launch-banner {
        flex-direction: column !important;
        text-align: center;
        gap: 16px !important;
      }
    }
    .pricing-cards-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 28px;
      align-items: stretch;
    }
    @media (max-width: 1100px) {
      .pricing-cards-grid {
        grid-template-columns: 1fr !important;
        gap: 24px !important;
      }
      .pricing-cards-grid > div {
        transform: none !important;
      }
    }
    .comparison-table-header,
    .comparison-table-row {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr;
    }
    @media (max-width: 700px) {
      .comparison-table-header,
      .comparison-table-row {
        grid-template-columns: 1.5fr 1fr 1fr 1fr !important;
      }
      .comparison-table-header > div,
      .comparison-table-row > div {
        padding: 12px 10px !important;
        font-size: 12px !important;
      }
    }
    
    /* ═══ RESPONSIVE BLOC 9 — CTA FINAL ═══ */
    .final-cta-buttons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 16px;
    }
    @media (max-width: 600px) {
      .final-cta-buttons {
        flex-direction: column !important;
        gap: 12px !important;
      }
      .final-cta-buttons button {
        width: 100% !important;
        justify-content: center;
      }
    }
    .reassurance-capsules {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 14px;
    }
    @media (max-width: 600px) {
      .reassurance-capsules {
        gap: 10px !important;
      }
      .reassurance-capsules span {
        font-size: 13px !important;
        padding: 10px 14px !important;
      }
    }
    
    /* ═══ OPTIMISATIONS MOBILE GLOBALES ═══ */
    @media (max-width: 480px) {
      /* Réduire les paddings sur très petits écrans */
      section {
        padding-left: 16px !important;
        padding-right: 16px !important;
      }
      
      /* Ajuster les titres pour éviter le débordement */
      h2 {
        word-break: break-word;
        hyphens: auto;
      }
      
      /* Cartes plus compactes */
      .kpi-cards-grid > div,
      .benefits-grid-2col > div,
      .agents-grid-12 > div {
        padding: 20px !important;
      }
      
      /* Grille agents en 1 colonne sur très petits écrans */
      .agents-grid-12 {
        grid-template-columns: 1fr !important;
      }
      
      /* Tableau comparatif plus compact */
      .comparison-table-header > div,
      .comparison-table-row > div {
        padding: 10px 6px !important;
        font-size: 11px !important;
      }
    }
    
    /* Compensation pour le bouton fixe en bas (Ouvre ton cockpit) */
    @media (max-width: 768px) {
      .sa-page-wrapper {
        padding-bottom: 100px;
      }
    }
  `}</style>
);

// ══════════════════════════════════════════════════════════════════════════════
// COMPOSANTS
// ══════════════════════════════════════════════════════════════════════════════

// Card Expert
const ExpertCard = ({ expert, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ delay: index * 0.03 }}
    className="sa-card"
    style={{ height: '100%', padding: 24 }}
  >
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 14 }}>
      <div style={{
        width: 48, height: 48, borderRadius: 12,
        background: `linear-gradient(135deg, ${expert.poleColor}15 0%, ${expert.poleColor}25 100%)`,
        border: `2px solid ${expert.poleColor}30`,
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24
      }}>
        {expert.emoji}
      </div>
      <div style={{ flex: 1 }}>
        <span style={{
          display: 'inline-block', padding: '3px 8px', borderRadius: 999,
          background: `${expert.poleColor}15`, color: expert.poleColor,
          fontSize: 9, fontWeight: 700, marginBottom: 4
        }}>
          {expert.pole}
        </span>
        <h4 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 700, fontSize: 15, color: C.navyDark, margin: 0 }}>
          {expert.name}
        </h4>
      </div>
    </div>
    <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6, marginBottom: 12 }}>
      {expert.desc}
    </p>
    <p style={{ fontSize: 11, color: '#94a3b8', fontStyle: 'italic', marginBottom: 10 }}>
      📂 Ancré dans : {expert.ancre}
    </p>
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '5px 10px', borderRadius: 6,
      background: 'rgba(249,115,22,0.1)', color: '#E8650A',
      fontSize: 10, fontWeight: 600
    }}>
      ✏️ Renommable : {expert.exempleNom}
    </div>
  </motion.div>
);

// Scenario Card
const ScenarioCard = ({ scenario, num, fullWidth = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    className="sa-scenario"
    style={{ gridColumn: fullWidth ? '1 / -1' : 'auto' }}
  >
    <div className="sa-scenario-header">
      <span className="sa-scenario-num">{num}</span>
      <span style={{ fontWeight: 600, fontSize: 14 }}>{scenario.title}</span>
    </div>
    <div className="sa-scenario-body">
      {scenario.steps.map((step, i) => (
        <div key={i} className="sa-scenario-step">
          <div className="sa-scenario-dot" style={{ background: step.color }}>
            {i + 1}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: step.color, marginBottom: 4, textTransform: 'uppercase' }}>
              {step.agent}
            </div>
            <p style={{ fontSize: 13, color: C.navyDark, lineHeight: 1.6, margin: 0 }}>
              {step.text}
            </p>
          </div>
        </div>
      ))}
    </div>
    <div className="sa-scenario-result">
      ✅ {scenario.result}
    </div>
  </motion.div>
);

// ══════════════════════════════════════════════════════════════════════════════
// PAGE PRINCIPALE
// ══════════════════════════════════════════════════════════════════════════════
export default function EquipeAgentsIAPage() {
  const [showCalcModal, setShowCalcModal] = useState(false);
  const [showCalcModalComplete, setShowCalcModalComplete] = useState(false);
  
  return (
    <ImmersiveEspaceProWrapper>
      <GlobalStyles />
      <UnifiedHeader />
      <EspaceProNav />
      <EspaceProSectionsNav />
      <EspaceProSectionsNavSpacer />
      
      {/* ═══════════════════════════════════════════════════════════════════
          MODAL — CALCUL DÉTAILLÉ COÛT HUMAIN VS ABRACADAPRO
      ═══════════════════════════════════════════════════════════════════ */}
      <AnimatePresence>
        {showCalcModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowCalcModal(false)}
            style={{
              position: 'fixed', inset: 0, zIndex: 9999,
              background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: 20
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 30 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 30 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                background: C.white, borderRadius: 24,
                maxWidth: 800, width: '100%', maxHeight: '90vh',
                overflow: 'auto', position: 'relative'
              }}
            >
              {/* Header du modal */}
              <div style={{
                background: `linear-gradient(135deg, ${C.navy} 0%, ${C.navyLight} 100%)`,
                padding: 'clamp(24px, 4vw, 40px)', color: C.white,
                borderRadius: '24px 24px 0 0'
              }}>
                <button
                  onClick={() => setShowCalcModal(false)}
                  style={{
                    position: 'absolute', top: 16, right: 16,
                    width: 36, height: 36, borderRadius: '50%',
                    background: 'rgba(255,255,255,0.2)', border: 'none',
                    color: C.white, fontSize: 18, cursor: 'pointer'
                  }}
                >
                  ✕
                </button>
                <div style={{ fontSize: 12, color: C.orange, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>
                  📊 Analyse détaillée
                </div>
                <h3 style={{ fontSize: 'clamp(22px, 4vw, 32px)', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", color: C.white }}>
                  Ce que coûte une vraie équipe<br />
                  <span style={{ color: C.orange }}>vs AbracadaPro</span>
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.7)', marginTop: 12, fontSize: 14 }}>
                  Données INSEE, URSSAF, observatoires des métiers 2024-2025
                </p>
              </div>
              
              {/* Corps du modal */}
              <div style={{ padding: 'clamp(24px, 4vw, 40px)' }}>
                
                {/* Méthodologie */}
                <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, marginBottom: 24 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#64748b', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Méthodologie
                  </div>
                  <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, margin: 0 }}>
                    Coût total employeur = salaire brut + charges patronales (45%) + congés payés + mutuelle obligatoire + formation professionnelle + arrêts maladie + 13ème mois éventuel.
                  </p>
                </div>

                {/* Tableau des coûts */}
                <div style={{ marginBottom: 32 }}>
                  <h4 style={{ fontSize: 16, fontWeight: 700, color: C.navyDark, marginBottom: 16 }}>
                    💰 Coût réel employeur par poste
                  </h4>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr style={{ background: C.navy, color: C.white }}>
                          <th style={{ padding: '12px 16px', textAlign: 'left', borderRadius: '8px 0 0 0' }}>Poste</th>
                          <th style={{ padding: '12px 16px', textAlign: 'right' }}>Minimum/an</th>
                          <th style={{ padding: '12px 16px', textAlign: 'right' }}>Maximum/an</th>
                          <th style={{ padding: '12px 16px', textAlign: 'right', borderRadius: '0 8px 0 0', background: C.orange }}>Coût moyen/an</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { emoji: '⚡', role: 'Super Assistante de Direction', min: '63 000€', max: '90 500€', avg: '76 750€' },
                          { emoji: '💼', role: 'Commercial', min: '58 000€', max: '90 000€', avg: '74 000€' },
                          { emoji: '🎧', role: 'Service Client', min: '36 800€', max: '49 200€', avg: '43 000€' },
                          { emoji: '📋', role: 'Assistante Administrative', min: '36 600€', max: '46 100€', avg: '41 350€' },
                          { emoji: '🏗️', role: 'Chef de Chantier', min: '62 400€', max: '94 750€', avg: '78 575€' },
                        ].map((item, i) => (
                          <tr key={i} style={{ background: i % 2 === 0 ? '#f8fafc' : C.white, borderBottom: '1px solid #e2e8f0' }}>
                            <td style={{ padding: '12px 16px' }}><span style={{ marginRight: 8 }}>{item.emoji}</span>{item.role}</td>
                            <td style={{ padding: '12px 16px', textAlign: 'right', color: '#64748b' }}>{item.min}</td>
                            <td style={{ padding: '12px 16px', textAlign: 'right', color: '#64748b' }}>{item.max}</td>
                            <td style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 700, color: C.orange }}>{item.avg}</td>
                          </tr>
                        ))}
                        <tr style={{ background: `${C.navy}10`, fontWeight: 700 }}>
                          <td style={{ padding: '14px 16px', borderRadius: '0 0 0 8px' }}>TOTAL</td>
                          <td style={{ padding: '14px 16px', textAlign: 'right', color: '#64748b' }}>256 800€</td>
                          <td style={{ padding: '14px 16px', textAlign: 'right', color: '#64748b' }}>370 550€</td>
                          <td style={{ padding: '14px 16px', textAlign: 'right', color: '#ef4444', fontSize: 16, borderRadius: '0 0 8px 0', background: `${C.orange}15` }}>313 675€</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Ce qu'on n'a pas compté */}
                <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: 20, marginBottom: 32 }}>
                  <h4 style={{ fontSize: 14, fontWeight: 700, color: '#dc2626', marginBottom: 12 }}>
                    ⚠️ Et on n'a pas compté :
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8 }}>
                    {[
                      '17 jours d\'arrêt maladie/an/salarié',
                      'Turnover (3-6 mois de salaire par recrutement)',
                      'Périodes sans remplaçant pendant les congés',
                      'Montée en compétence (3-6 mois)',
                      'Erreurs humaines',
                      'Fatigue, démotivation, mauvais jours'
                    ].map((item, i) => (
                      <div key={i} style={{ fontSize: 12, color: '#991b1b', display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ color: '#dc2626' }}>•</span> {item}
                      </div>
                    ))}
                  </div>
                </div>

                {/* VS Comparatif */}
                <div style={{ background: `linear-gradient(135deg, ${C.orange}10 0%, ${C.orange}05 100%)`, border: `2px solid ${C.orange}30`, borderRadius: 16, padding: 24, marginBottom: 24 }}>
                  <h4 style={{ fontSize: 16, fontWeight: 700, color: C.navyDark, marginBottom: 20, textAlign: 'center' }}>
                    🎯 La comparaison qui parle
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
                    {/* Équipe humaine */}
                    <div style={{ background: C.white, borderRadius: 12, padding: 20, textAlign: 'center', border: '1px solid #e2e8f0' }}>
                      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8, textTransform: 'uppercase' }}>Équipe humaine (5 pers.)</div>
                      <div style={{ fontSize: 32, fontWeight: 800, color: '#ef4444', textDecoration: 'line-through', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>313 675€</div>
                      <div style={{ fontSize: 13, color: '#64748b' }}>/an (coût moyen)</div>
                    </div>
                    {/* AbracadaPro Business */}
                    <div style={{ background: C.white, borderRadius: 12, padding: 20, textAlign: 'center', border: `2px solid ${C.orange}` }}>
                      <div style={{ fontSize: 12, color: C.orange, marginBottom: 8, fontWeight: 700, textTransform: 'uppercase' }}>AbracadaPro Business</div>
                      <div style={{ fontSize: 32, fontWeight: 800, color: C.orange, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>999€</div>
                      <div style={{ fontSize: 13, color: '#64748b' }}>/an (5 agents)</div>
                      <div style={{ marginTop: 8, fontSize: 14, fontWeight: 700, color: C.green }}>314× moins cher</div>
                    </div>
                    {/* AbracadaPro Premium */}
                    <div style={{ background: C.navy, borderRadius: 12, padding: 20, textAlign: 'center', color: C.white }}>
                      <div style={{ fontSize: 12, color: C.orange, marginBottom: 8, fontWeight: 700, textTransform: 'uppercase' }}>⭐ AbracadaPro Premium</div>
                      <div style={{ fontSize: 28, fontWeight: 800, color: C.orange, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>149€ <span style={{ fontWeight: 500, fontSize: 16 }}>/ mois</span></div>
                      <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>ou <span style={{ fontWeight: 700, color: C.orange }}>1 490€</span> / an</div>
                      <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>(12 agents)</div>
                      <div style={{ marginTop: 8, fontSize: 14, fontWeight: 700, color: '#4ade80' }}>537× moins cher</div>
                    </div>
                  </div>
                </div>

                {/* Citation finale */}
                <div style={{ textAlign: 'center', padding: '24px 16px', background: '#f8fafc', borderRadius: 12 }}>
                  <p style={{ fontSize: 18, fontWeight: 600, color: C.navyDark, margin: 0, lineHeight: 1.5 }}>
                    "<span style={{ color: C.orange }}>99€ par mois</span> pour une équipe de 5 experts.<br />
                    Disponible 24h/24, 7j/7."
                  </p>
                </div>

                {/* CTA */}
                <div style={{ textAlign: 'center', marginTop: 32 }}>
                  <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    padding: '16px 32px', borderRadius: 12,
                    background: `linear-gradient(135deg, ${C.green} 0%, #16a34a 100%)`,
                    color: C.white, fontWeight: 700, fontSize: 16, textDecoration: 'none',
                    boxShadow: '0 8px 24px rgba(34,197,94,0.3)'
                  }}>
                    👑 Rejoindre les Membres Fondateurs
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ═══════════════════════════════════════════════════════════════════
          MODAL 2 — CALCUL DÉTAILLÉ FORMULE PREMIUM (12 AGENTS)
      ═══════════════════════════════════════════════════════════════════ */}
      <AnimatePresence>
        {showCalcModalComplete && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowCalcModalComplete(false)}
            style={{
              position: 'fixed', inset: 0, zIndex: 9999,
              background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: 20
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 30 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 30 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                background: C.white, borderRadius: 24,
                maxWidth: 900, width: '100%', maxHeight: '90vh',
                overflow: 'auto', position: 'relative'
              }}
            >
              {/* Header du modal */}
              <div style={{
                background: `linear-gradient(135deg, ${C.navy} 0%, ${C.navyLight} 100%)`,
                padding: 'clamp(24px, 4vw, 40px)', color: C.white,
                borderRadius: '24px 24px 0 0'
              }}>
                <button
                  onClick={() => setShowCalcModalComplete(false)}
                  style={{
                    position: 'absolute', top: 16, right: 16,
                    width: 36, height: 36, borderRadius: '50%',
                    background: 'rgba(255,255,255,0.2)', border: 'none',
                    color: C.white, fontSize: 18, cursor: 'pointer'
                  }}
                >
                  ✕
                </button>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(249,115,22,0.2)', padding: '6px 12px', borderRadius: 999, marginBottom: 12 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: C.orange }}>⭐ FORMULE PREMIUM</span>
                </div>
                <h3 style={{ fontSize: 'clamp(22px, 4vw, 32px)', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", color: C.white }}>
                  12 experts — Coût réel<br />
                  <span style={{ color: C.orange }}>vs AbracadaPro Premium</span>
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.7)', marginTop: 12, fontSize: 14 }}>
                  Données INSEE, URSSAF, observatoires des métiers 2024-2025
                </p>
              </div>
              
              {/* Corps du modal */}
              <div style={{ padding: 'clamp(24px, 4vw, 40px)' }}>
                
                {/* Tableau des 12 postes */}
                <div style={{ marginBottom: 32 }}>
                  <h4 style={{ fontSize: 16, fontWeight: 700, color: C.navyDark, marginBottom: 16 }}>
                    💰 Coût réel employeur — 12 postes
                  </h4>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                      <thead>
                        <tr style={{ background: C.navy, color: C.white }}>
                          <th style={{ padding: '10px 12px', textAlign: 'left', borderRadius: '8px 0 0 0' }}>Poste</th>
                          <th style={{ padding: '10px 12px', textAlign: 'right' }}>Minimum/an</th>
                          <th style={{ padding: '10px 12px', textAlign: 'right' }}>Maximum/an</th>
                          <th style={{ padding: '10px 12px', textAlign: 'right', borderRadius: '0 8px 0 0', background: C.orange }}>Coût moyen/an</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { emoji: '⚡', role: 'Super Assistante de Direction', min: '63 000€', max: '90 500€', avg: '76 750€' },
                          { emoji: '💼', role: 'Commercial', min: '58 000€', max: '90 000€', avg: '74 000€' },
                          { emoji: '🎧', role: 'Service Client', min: '36 800€', max: '49 200€', avg: '43 000€' },
                          { emoji: '📋', role: 'Assistante Administrative', min: '36 600€', max: '46 100€', avg: '41 350€' },
                          { emoji: '🏗️', role: 'Chef de Chantier', min: '62 400€', max: '94 750€', avg: '78 575€' },
                          { emoji: '📣', role: 'Community Manager', min: '43 800€', max: '66 300€', avg: '55 050€' },
                          { emoji: '🛡️', role: 'Modérateur & E-réputation', min: '42 100€', max: '61 000€', avg: '51 550€' },
                          { emoji: '📈', role: 'Responsable Marketing', min: '59 600€', max: '89 250€', avg: '74 425€' },
                          { emoji: '🎨', role: 'Graphiste + Monteur Vidéo', min: '48 900€', max: '75 050€', avg: '61 975€' },
                          { emoji: '💻', role: 'Webmaster', min: '49 900€', max: '76 100€', avg: '63 000€' },
                          { emoji: '⚖️', role: 'Conseil Juridique', min: '69 750€', max: '110 000€', avg: '89 875€' },
                          { emoji: '📊', role: 'Analyste Financier', min: '61 800€', max: '94 000€', avg: '77 900€' },
                          { emoji: '🚚', role: 'Responsable Logistique', min: '49 600€', max: '75 600€', avg: '62 600€' },
                        ].map((item, i) => (
                          <tr key={i} style={{ background: i % 2 === 0 ? '#f8fafc' : C.white, borderBottom: '1px solid #e2e8f0' }}>
                            <td style={{ padding: '10px 12px' }}><span style={{ marginRight: 6 }}>{item.emoji}</span>{item.role}</td>
                            <td style={{ padding: '10px 12px', textAlign: 'right', color: '#64748b' }}>{item.min}</td>
                            <td style={{ padding: '10px 12px', textAlign: 'right', color: '#64748b' }}>{item.max}</td>
                            <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: C.orange }}>{item.avg}</td>
                          </tr>
                        ))}
                        <tr style={{ background: `${C.navy}10`, fontWeight: 700 }}>
                          <td style={{ padding: '12px', borderRadius: '0 0 0 8px' }}>TOTAL (12 postes)</td>
                          <td style={{ padding: '12px', textAlign: 'right', color: '#64748b' }}>682 250€</td>
                          <td style={{ padding: '12px', textAlign: 'right', color: '#64748b' }}>917 850€</td>
                          <td style={{ padding: '12px', textAlign: 'right', color: '#ef4444', fontSize: 15, borderRadius: '0 0 8px 0', background: `${C.orange}15` }}>800 050€</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Ce qu'on n'a pas compté */}
                <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: 20, marginBottom: 32 }}>
                  <h4 style={{ fontSize: 14, fontWeight: 700, color: '#dc2626', marginBottom: 12 }}>
                    ⚠️ Et on n'a pas compté :
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8 }}>
                    {[
                      '221 jours arrêt maladie/an (13 pers.)',
                      '325 jours de congés/an (13 pers.)',
                      'Turnover (3-6 mois de salaire)',
                      'Locaux, postes de travail, équipements',
                      'Conflits, gestion RH, management',
                      'Erreurs humaines et conséquences'
                    ].map((item, i) => (
                      <div key={i} style={{ fontSize: 12, color: '#991b1b', display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ color: '#dc2626' }}>•</span> {item}
                      </div>
                    ))}
                  </div>
                </div>

                {/* VS Comparatif */}
                <div style={{ background: `linear-gradient(135deg, ${C.orange}10 0%, ${C.orange}05 100%)`, border: `2px solid ${C.orange}30`, borderRadius: 16, padding: 24, marginBottom: 24 }}>
                  <h4 style={{ fontSize: 16, fontWeight: 700, color: C.navyDark, marginBottom: 20, textAlign: 'center' }}>
                    🎯 La comparaison qui tue
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                    {/* Équipe humaine */}
                    <div style={{ background: C.white, borderRadius: 12, padding: 20, textAlign: 'center', border: '1px solid #e2e8f0' }}>
                      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8, textTransform: 'uppercase' }}>Équipe humaine (12 postes)</div>
                      <div style={{ fontSize: 28, fontWeight: 800, color: '#ef4444', textDecoration: 'line-through', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>800 050€</div>
                      <div style={{ fontSize: 13, color: '#64748b' }}>/an (coût moyen)</div>
                      <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>66 670€/mois</div>
                    </div>
                    {/* AbracadaPro Premium */}
                    <div style={{ background: C.navy, borderRadius: 12, padding: 20, textAlign: 'center', color: C.white }}>
                      <div style={{ fontSize: 12, color: C.orange, marginBottom: 8, fontWeight: 700, textTransform: 'uppercase' }}>⭐ AbracadaPro Premium</div>
                      <div style={{ fontSize: 24, fontWeight: 800, color: C.orange, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>149€ <span style={{ fontWeight: 500, fontSize: 14 }}>/ mois</span></div>
                      <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>ou <span style={{ fontWeight: 700, color: C.orange }}>1 490€</span> / an</div>
                      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>(12 agents IA)</div>
                      <div style={{ marginTop: 8, fontSize: 14, fontWeight: 700, color: '#4ade80' }}>537× moins cher</div>
                    </div>
                  </div>
                </div>

                {/* Citation finale */}
                <div style={{ textAlign: 'center', padding: '24px 16px', background: '#f8fafc', borderRadius: 12 }}>
                  <p style={{ fontSize: 18, fontWeight: 600, color: C.navyDark, margin: 0, lineHeight: 1.5 }}>
                    "<span style={{ color: '#ef4444' }}>800 050€</span> par an ou <span style={{ color: C.orange }}>149€</span> par mois.<br />
                    Même équipe. Même expertise. Disponible 24h/24."
                  </p>
                </div>

                {/* CTA */}
                <div style={{ textAlign: 'center', marginTop: 32 }}>
                  <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    padding: '16px 32px', borderRadius: 12,
                    background: `linear-gradient(135deg, ${C.green} 0%, #16a34a 100%)`,
                    color: C.white, fontWeight: 700, fontSize: 16, textDecoration: 'none',
                    boxShadow: '0 8px 24px rgba(34,197,94,0.3)'
                  }}>
                    👑 Rejoindre les Membres Fondateurs
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
      <div className="sa-root sa-page-wrapper">
        

        {/* ═══════════════════════════════════════════════════════════════════
            HERO PREMIUM V2 — SUPER ASSISTANT + ÉQUIPE AGENTS IA
            Design fidèle au visuel de référence fourni
        ═══════════════════════════════════════════════════════════════════ */}
        <section id="hero" className="agents-hero-v2" style={{ 
          position: 'relative',
          overflow: 'hidden',
          minHeight: '920px',
          padding: '60px clamp(24px, 5vw, 64px) 28px',
          background: `
            radial-gradient(ellipse 80% 60% at 65% 40%, rgba(29,78,137,0.5) 0%, transparent 55%),
            radial-gradient(circle at 20% 80%, rgba(255,122,0,0.08) 0%, transparent 40%),
            linear-gradient(165deg, #072B57 0%, #103A6D 35%, #1D4E89 70%, #072B57 100%)
          `,
          color: '#ffffff',
        }}>
          {/* Grille subtile premium */}
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `
              linear-gradient(rgba(150,190,255,0.035) 1px, transparent 1px),
              linear-gradient(90deg, rgba(150,190,255,0.035) 1px, transparent 1px)
            `,
            backgroundSize: '48px 48px',
            opacity: 0.7,
            pointerEvents: 'none',
          }} />
          
          {/* Glow central */}
          <div style={{
            position: 'absolute',
            top: '35%',
            right: '25%',
            width: 600,
            height: 600,
            background: 'radial-gradient(circle, rgba(29,78,137,0.4) 0%, transparent 60%)',
            filter: 'blur(80px)',
            pointerEvents: 'none',
          }} />

          <div style={{ 
            position: 'relative', 
            zIndex: 2, 
            maxWidth: 1520, 
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: '47% 53%',
            gap: 48,
            alignItems: 'flex-start',
          }} className="agents-hero-v2-grid">
            
            {/* ═══ COLONNE GAUCHE — Marketing & Conversion ═══ */}
            <div style={{ paddingTop: 20 }}>
              {/* Badge */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '10px 20px',
                  borderRadius: 999,
                  background: 'rgba(249, 115, 22, 0.15)',
                  border: '1px solid rgba(249, 115, 22, 0.3)',
                  color: '#F97316',
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: 28,
                }}
              >
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Ta dream team dans ta poche
              </motion.div>

              {/* Titre principal - 2 lignes en blanc + sous-titre orange */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                style={{ marginBottom: 12 }}
              >
                <h1 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 900,
                  fontSize: 'clamp(42px, 4.5vw, 64px)',
                  lineHeight: 1.05,
                  letterSpacing: '-0.04em',
                  color: '#ffffff',
                  margin: 0,
                }}>
                  Un Super Assistant +
                </h1>
                <h1 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 900,
                  fontSize: 'clamp(42px, 4.5vw, 64px)',
                  lineHeight: 1.05,
                  letterSpacing: '-0.04em',
                  color: '#ffffff',
                  margin: '4px 0',
                }}>
                  une équipe d'Agents IA
                </h1>
                <h2 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: 'clamp(26px, 2.8vw, 40px)',
                  lineHeight: 1.15,
                  letterSpacing: '-0.02em',
                  color: '#FF7A00',
                  margin: '8px 0 0',
                }}>
                  Qui travaillent 7j/7, 24h/24
                </h2>
                {/* Ligne orange décorative */}
                <div style={{
                  width: 60,
                  height: 4,
                  background: '#FF7A00',
                  borderRadius: 2,
                  marginTop: 20,
                }} />
              </motion.div>

              {/* Paragraphe explicatif */}
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                style={{
                  fontSize: 'clamp(18px, 1.8vw, 22px)',
                  lineHeight: 1.65,
                  color: 'rgba(255,255,255,0.78)',
                  maxWidth: 540,
                  marginBottom: 32,
                  marginTop: 24,
                }}
              >
                Tu peux démarrer avec ton Super Assistant,<br />
                puis activer une <span style={{ color: '#FF7A00', fontWeight: 700 }}>équipe d'agents IA</span> spécialisés<br />
                qui collaborent entre eux dans ton Cockpit.
              </motion.p>

              {/* ═══ PRIX SIMPLIFIÉ (Style BoutiquePage) ═══ */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                style={{ marginBottom: 8 }}
              >
                <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16 }}>À partir de </span>
                <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 42, color: '#fff' }}>50€</span>
                <span style={{ color: '#FF7A00', fontSize: 16, fontWeight: 600 }}>*</span>
                <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 16 }}> / Mois</span>
              </motion.div>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.35 }}
                style={{ 
                  fontSize: 12, 
                  color: 'rgba(255,255,255,0.5)', 
                  marginBottom: 28,
                  fontStyle: 'italic',
                }}
              >
                *Prix mensuel pour un Abonnement Annuel
              </motion.p>

              {/* CTAs (Style BoutiquePage) */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}
              >
                <Link
                  to="/pro/fondateur"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '16px 28px',
                    borderRadius: 12,
                    background: '#22C55E',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: 15,
                    textDecoration: 'none',
                    boxShadow: '0 8px 24px rgba(34,197,94,0.35)',
                    transition: 'transform 0.2s',
                  }}
                >
                  ✨ Devenir Membre Fondateur →
                </Link>
                <Link
                  to="/pro/tarifs"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '16px 28px',
                    borderRadius: 12,
                    background: '#FF7A00',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: 15,
                    textDecoration: 'none',
                    boxShadow: '0 8px 24px rgba(249,115,22,0.35)',
                    transition: 'transform 0.2s',
                  }}
                >
                  Voir les tarifs
                </Link>
              </motion.div>
            </div>

            {/* ═══ COLONNE DROITE — COMPOSITION PREMIUM CENTRÉE ═══ */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.3 }}
              className="hero-ai-visual"
              style={{ 
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: 620,
                paddingTop: 10,
              }}
            >
              {/* ═══ SUPER ASSISTANT — CENTRÉ EN HAUT ═══ */}
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                style={{ zIndex: 12, marginBottom: 25, position: 'relative' }}
              >
                <div style={{
                  width: 220,
                  padding: '14px 18px',
                  borderRadius: 18,
                  background: 'rgba(7, 29, 54, 0.88)',
                  backdropFilter: 'blur(14px)',
                  border: '1.5px solid rgba(249,115,22,0.75)',
                  boxShadow: '0 0 36px rgba(249,115,22,0.25), 0 20px 50px rgba(0,0,0,0.35)',
                  textAlign: 'center',
                }}>
                  <div style={{
                    width: 42, height: 42, borderRadius: '50%',
                    background: 'linear-gradient(135deg, #FF7A00 0%, #F97316 100%)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 10px',
                    boxShadow: '0 0 28px rgba(249,115,22,0.6)',
                    border: '2px solid rgba(255,255,255,0.2)',
                  }}>
                    <span style={{ fontSize: 20 }}>✨</span>
                  </div>
                  <div style={{ fontWeight: 850, fontSize: 15, color: '#FF8C1A', marginBottom: 4 }}>Super Assistant</div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', lineHeight: 1.4 }}>Pilote et orchestre toute l'équipe</div>
                </div>
              </motion.div>

              {/* ═══ LIGNE CONNEXION SUPER ASSISTANT → PHONE ═══ */}
              <div style={{
                width: 3,
                height: 30,
                background: 'linear-gradient(to bottom, rgba(249,115,22,0.8), rgba(249,115,22,0.3))',
                borderRadius: 2,
                boxShadow: '0 0 8px rgba(249,115,22,0.5)',
                marginBottom: -10,
                zIndex: 5,
              }} />

              {/* ═══ ZONE CENTRALE : AGENTS + PHONE ═══ */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 30,
                position: 'relative',
                marginTop: -55,
              }}>
                {/* COLONNE GAUCHE — AGENTS */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 18, zIndex: 8 }}>
                  {/* Marketing */}
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>📣</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Marketing</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Stratégie et campagnes</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Service Client */}
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.45 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #06B6D4 0%, #0891B2 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>🎧</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Service Client</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Répond et suit vos clients</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Commercial */}
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.5 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>📈</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Commercial</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Prospecte et négocie</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Administratif */}
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.55 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>📁</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Administratif</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Gère documents et contrats</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Modérateur */}
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.6 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>🛡️</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Modérateur</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Protège votre e-réputation</div>
                      </div>
                    </div>
                  </motion.div>
                </div>

                {/* TÉLÉPHONE CENTRAL */}
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.35 }}
                  style={{ position: 'relative', zIndex: 10 }}
                >
                  {/* Halo derrière */}
                  <div style={{
                    position: 'absolute',
                    width: 400,
                    height: 480,
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'radial-gradient(circle, rgba(59,130,246,0.2) 0%, rgba(59,130,246,0.05) 50%, transparent 70%)',
                    filter: 'blur(15px)',
                    zIndex: -1,
                    pointerEvents: 'none',
                  }} />
                  <img 
                    src="https://customer-assets.emergentagent.com/job_organize-smart/artifacts/xmbgny7f_image.png"
                    alt="Cockpit IA - Ma Dream Team"
                    style={{
                      width: 420,
                      height: 'auto',
                      filter: 'drop-shadow(0 38px 75px rgba(0,0,0,0.48))',
                      transform: 'scale(2.50) translateY(25px)',
                    }}
                  />
                </motion.div>

                {/* COLONNE DROITE — AGENTS */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 18, zIndex: 8 }}>
                  {/* Webmaster */}
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>🌐</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Webmaster</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Gestion site et technique</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Chef de Chantier */}
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.45 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>🏗️</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Chef de Chantier</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Planifie et suit les travaux</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Community Manager */}
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.5 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #EC4899 0%, #DB2777 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>📱</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Community Manager</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Anime vos réseaux</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Analyste Financier */}
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.55 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>📊</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Analyste Financier</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Analyse et tableaux de bord</div>
                      </div>
                    </div>
                  </motion.div>

                  {/* Graphiste / Monteur Vidéo */}
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.6 }}
                  >
                    <div style={{
                      width: 200,
                      padding: '14px 16px',
                      borderRadius: 18,
                      background: 'rgba(7, 29, 54, 0.85)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(160, 200, 255, 0.22)',
                      boxShadow: '0 18px 45px rgba(0,0,0,0.22)',
                      display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: 14,
                        background: 'linear-gradient(135deg, #A855F7 0%, #7C3AED 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: 22 }}>🎨</span>
                      </div>
                      <div>
                        <div style={{ fontWeight: 850, fontSize: 15, color: '#fff', lineHeight: 1.2 }}>Graphiste</div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)', lineHeight: 1.3, marginTop: 4 }}>Visuels et vidéos</div>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </div>

              {/* ═══ LIGNES DE CONNEXION SVG ═══ */}
              <svg 
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 1,
                  pointerEvents: 'none',
                }}
              >
                <defs>
                  <filter id="glowConn2">
                    <feGaussianBlur stdDeviation="2" result="blur"/>
                    <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
                  </filter>
                </defs>
                
                {/* Lignes gauche vers centre */}
                <path d="M 200 200 Q 280 220 340 270" fill="none" stroke="rgba(56,189,248,0.35)" strokeWidth="1.5" filter="url(#glowConn2)" />
                <path d="M 200 310 Q 280 310 340 340" fill="none" stroke="rgba(56,189,248,0.35)" strokeWidth="1.5" filter="url(#glowConn2)" />
                <path d="M 200 420 Q 280 400 340 380" fill="none" stroke="rgba(56,189,248,0.35)" strokeWidth="1.5" filter="url(#glowConn2)" />
                
                {/* Lignes droite vers centre */}
                <path d="M 590 200 Q 510 220 450 270" fill="none" stroke="rgba(56,189,248,0.35)" strokeWidth="1.5" filter="url(#glowConn2)" />
                <path d="M 590 310 Q 510 310 450 340" fill="none" stroke="rgba(56,189,248,0.35)" strokeWidth="1.5" filter="url(#glowConn2)" />
                <path d="M 590 420 Q 510 400 450 380" fill="none" stroke="rgba(56,189,248,0.35)" strokeWidth="1.5" filter="url(#glowConn2)" />
              </svg>
            </motion.div>
          </div>

          {/* ═══ BARRE AVANTAGES EN BAS ═══ */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.7 }}
            style={{
              position: 'relative',
              zIndex: 2,
              maxWidth: 1400,
              margin: '48px auto 0',
              background: 'rgba(7,43,87,0.65)',
              border: '1px solid rgba(140,190,255,0.15)',
              borderRadius: 22,
              padding: '24px 40px',
              backdropFilter: 'blur(12px)',
            }}
          >
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(6, 1fr)',
              gap: 24,
            }} className="benefits-bar-v2">
              {[
                { icon: '🕐', title: '24h/24', sub: 'Toujours en action' },
                { icon: '📅', title: '7j/7', sub: 'Même le week-end' },
                { icon: '🔗', title: 'Tous connectés', sub: 'Collaboration en temps réel' },
                { icon: '🔒', title: 'Données sécurisées', sub: 'Hébergement en Europe' },
                { icon: '⚡', title: 'Ultra réactifs', sub: 'Réponse en quelques secondes' },
                { icon: '💚', title: 'Zéro stress', sub: 'On s\'occupe de tout' },
              ].map((item, i) => (
                <div key={i} style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  gap: 6,
                }}>
                  <div style={{ fontSize: 24, marginBottom: 4 }}>{item.icon}</div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: '#fff' }}>{item.title}</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', lineHeight: 1.3 }}>{item.sub}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            SECTION — LE CONCEPT SIMPLEMENT (Bloc 2)
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: '#F9FAFB',
          padding: 'clamp(60px, 8vw, 100px) clamp(20px, 5vw, 40px)',
        }}>
          <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Badge en haut */}
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <span style={{
                display: 'inline-block',
                background: 'rgba(249, 115, 22, 0.1)',
                color: '#F97316',
                padding: '10px 20px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 600,
              }}>
                Le concept simplement
              </span>
            </div>
            
            {/* Titre principal */}
            <h2 style={{
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(32px, 5vw, 52px)',
              lineHeight: 1.1,
              marginBottom: 24,
              color: C.navy,
            }}>
              Un assistant d'abord.<br />
              <span style={{ color: '#F97316' }}>Une équipe ensuite.</span>
            </h2>
            
            {/* Sous-texte */}
            <div style={{
              textAlign: 'center',
              maxWidth: 700,
              margin: '0 auto 56px',
              color: '#6B7280',
              fontSize: 'clamp(16px, 2vw, 18px)',
              lineHeight: 1.7,
            }}>
              <p style={{ margin: '0 0 16px' }}>
                Tu commences avec ton <strong style={{ color: C.navy }}>Super Assistant IA</strong>.<br />
                Il comprend tes messages, tes notes vocales et t'aide à organiser ton quotidien.
              </p>
              <p style={{ margin: 0 }}>
                Quand ton activité grandit, tu peux lui ajouter des <strong style={{ color: C.navy }}>agents IA spécialisés</strong>.
              </p>
            </div>
            
            {/* 3 Cartes */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 24,
              marginBottom: 48,
            }} className="concept-cards-grid">
              
              {/* CARTE 1 — Super Assistant */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0 }}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 20,
                  padding: 28,
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Icône */}
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: 14,
                  background: 'rgba(30, 58, 95, 0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 20,
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.navy} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                    <path d="M8 9h8"/>
                    <path d="M8 13h4"/>
                  </svg>
                </div>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: 20,
                  color: C.navy,
                  marginBottom: 12,
                }}>
                  Ton Super Assistant
                </h3>
                
                <p style={{
                  color: '#6B7280',
                  fontSize: 15,
                  lineHeight: 1.6,
                  marginBottom: 24,
                  flex: 1,
                }}>
                  Tu écris ou tu parles.<br />
                  Il comprend, résume, organise et t'aide à avancer.
                </p>
                
                {/* Badge bas */}
                <div style={{
                  background: 'rgba(34, 197, 94, 0.1)',
                  color: '#16a34a',
                  padding: '8px 14px',
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 600,
                  display: 'inline-block',
                  alignSelf: 'flex-start',
                }}>
                  ✓ Inclus dès la première formule
                </div>
              </motion.div>
              
              {/* CARTE 2 — Cockpit (CARTE PRINCIPALE) */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 20,
                  padding: 28,
                  border: '2px solid #F97316',
                  boxShadow: '0 8px 32px rgba(249, 115, 22, 0.15)',
                  display: 'flex',
                  flexDirection: 'column',
                  transform: 'scale(1.02)',
                }}
              >
                {/* Icône */}
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: 14,
                  background: 'rgba(249, 115, 22, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 20,
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <path d="M3 9h18"/>
                    <path d="M9 21V9"/>
                  </svg>
                </div>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: 20,
                  color: C.navy,
                  marginBottom: 12,
                }}>
                  Ton Cockpit
                </h3>
                
                <p style={{
                  color: '#6B7280',
                  fontSize: 15,
                  lineHeight: 1.6,
                  marginBottom: 16,
                }}>
                  Tout passe par ton Cockpit :<br />
                  demandes, clients, tâches, devis, messages, documents.
                </p>
                
                {/* Mini éléments visuels */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 8,
                  marginBottom: 16,
                }}>
                  {['Clients & demandes', 'Tâches & agenda', 'Devis & projets', 'Messages & docs'].map((item, i) => (
                    <div key={i} style={{
                      background: '#FFF7ED',
                      padding: '6px 10px',
                      borderRadius: 6,
                      fontSize: 12,
                      color: '#C2410C',
                      fontWeight: 500,
                    }}>
                      {item}
                    </div>
                  ))}
                </div>
                
                <p style={{
                  color: C.navy,
                  fontSize: 15,
                  fontWeight: 600,
                  lineHeight: 1.5,
                  marginBottom: 0,
                  flex: 1,
                  display: 'flex',
                  alignItems: 'flex-end',
                }}>
                  Un seul endroit.<br />
                  Moins de dispersion. Plus de contrôle.
                </p>
              </motion.div>
              
              {/* CARTE 3 — Agents IA */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 20,
                  padding: 28,
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Icône */}
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: 14,
                  background: 'rgba(34, 197, 94, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 20,
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: 20,
                  color: C.navy,
                  marginBottom: 12,
                }}>
                  Tes Agents IA
                </h3>
                
                <p style={{
                  color: '#6B7280',
                  fontSize: 15,
                  lineHeight: 1.6,
                  marginBottom: 16,
                  flex: 1,
                }}>
                  Commercial, administratif, service client, chantier, marketing…<br /><br />
                  Tu ajoutes des agents spécialisés quand tu en as besoin.
                </p>
                
                {/* Badge bas */}
                <div style={{
                  background: 'rgba(30, 58, 95, 0.08)',
                  color: C.navy,
                  padding: '8px 14px',
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 600,
                  display: 'inline-block',
                  alignSelf: 'flex-start',
                }}>
                  Business & Premium
                </div>
              </motion.div>
            </div>
            
            {/* BANDEAU BAS */}
            <div style={{
              background: 'rgba(30, 58, 95, 0.04)',
              borderRadius: 20,
              padding: 'clamp(32px, 4vw, 48px)',
              border: '1px solid rgba(30, 58, 95, 0.08)',
            }}>
              {/* Texte principal du bandeau */}
              <p style={{
                textAlign: 'center',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: 'clamp(18px, 2.5vw, 24px)',
                color: C.navy,
                marginBottom: 32,
                lineHeight: 1.4,
              }}>
                Tu ne changes pas tout.<br />
                <span style={{ color: '#6B7280', fontWeight: 500 }}>Tu ajoutes une intelligence à ton organisation.</span>
              </p>
              
              {/* 4 mini blocs */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 20,
              }} className="concept-mini-grid">
                {[
                  { icon: '🎤', title: 'Notes vocales', desc: 'Tu parles, il structure.' },
                  { icon: '🎯', title: 'Cockpit inclus', desc: 'Tout reste centralisé.' },
                  { icon: '⚡', title: 'Agents évolutifs', desc: 'Tu ajoutes de la puissance quand tu veux.' },
                  { icon: '🔒', title: 'Tu gardes le contrôle', desc: "L'IA aide, tu décides." },
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.08 }}
                    style={{
                      textAlign: 'center',
                      padding: '20px 16px',
                      background: '#FFFFFF',
                      borderRadius: 14,
                      border: '1px solid #E5E7EB',
                    }}
                  >
                    <div style={{ fontSize: 28, marginBottom: 10 }}>{item.icon}</div>
                    <div style={{
                      fontWeight: 700,
                      fontSize: 14,
                      color: C.navy,
                      marginBottom: 6,
                    }}>
                      {item.title}
                    </div>
                    <div style={{
                      fontSize: 13,
                      color: '#6B7280',
                      lineHeight: 1.4,
                    }}>
                      {item.desc}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            BLOC 3 — CE QUE TU GAGNES CONCRÈTEMENT
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: '#FFFDF9',
          padding: 'clamp(70px, 10vw, 110px) clamp(20px, 5vw, 40px)',
        }}>
          <div style={{ maxWidth: 1240, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Badge haut */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: 'rgba(249, 115, 22, 0.10)',
                border: '1px solid rgba(249, 115, 22, 0.2)',
                color: '#F97316',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: '0.02em',
              }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Ce que tu gagnes
              </span>
            </div>
            
            {/* Titre principal */}
            <h2 style={{
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(38px, 5.5vw, 64px)',
              lineHeight: 1.05,
              marginBottom: 24,
              color: '#0F2A44',
            }}>
              Moins de charge mentale.<br />
              <span style={{ color: '#F97316' }}>Plus de temps pour ton métier.</span>
            </h2>
            
            {/* Sous-texte */}
            <p style={{
              textAlign: 'center',
              maxWidth: 760,
              margin: '0 auto 60px',
              fontSize: 'clamp(17px, 2vw, 20px)',
              lineHeight: 1.6,
              color: '#475569',
            }}>
              Ton Super Assistant IA t'aide à organiser, répondre, classer et avancer.<br />
              Quand tu ajoutes des agents IA, ton organisation devient encore plus puissante.
            </p>
            
            {/* ═══ LIGNE D'IMPACT — 4 CARTES KPI ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 20,
              marginBottom: 56,
            }} className="kpi-cards-grid">
              {[
                { 
                  title: 'Plus de réactivité', 
                  desc: 'Tu réponds plus vite, même quand tu es occupé.',
                  iconBg: '#DBEAFE',
                  iconColor: '#2563EB',
                  icon: (
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                    </svg>
                  )
                },
                { 
                  title: 'Moins d\'oublis', 
                  desc: 'Tes demandes, idées et actions ne restent plus dans ta tête.',
                  iconBg: '#FFEDD5',
                  iconColor: '#EA580C',
                  icon: (
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 11l3 3L22 4"/>
                      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                    </svg>
                  )
                },
                { 
                  title: 'Plus d\'organisation', 
                  desc: 'Tout revient dans ton Cockpit au lieu d\'être dispersé.',
                  iconBg: '#EDE9FE',
                  iconColor: '#7C3AED',
                  icon: (
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="7" height="7" rx="1"/>
                      <rect x="14" y="3" width="7" height="7" rx="1"/>
                      <rect x="3" y="14" width="7" height="7" rx="1"/>
                      <rect x="14" y="14" width="7" height="7" rx="1"/>
                    </svg>
                  )
                },
                { 
                  title: 'Plus de sérénité', 
                  desc: 'Tu gardes le contrôle sans tout porter seul.',
                  iconBg: '#DCFCE7',
                  iconColor: '#16A34A',
                  icon: (
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                      <path d="M9 12l2 2 4-4"/>
                    </svg>
                  )
                },
              ].map((kpi, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  style={{
                    background: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    borderRadius: 22,
                    padding: '28px 22px',
                    textAlign: 'center',
                    boxShadow: '0 18px 45px rgba(15, 42, 68, 0.07)',
                    transition: 'all 0.2s ease',
                    cursor: 'default',
                  }}
                  whileHover={{ y: -4, boxShadow: '0 24px 50px rgba(15, 42, 68, 0.12)' }}
                >
                  <div style={{
                    width: 56,
                    height: 56,
                    borderRadius: 14,
                    background: kpi.iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 16px',
                    color: kpi.iconColor,
                  }}>
                    {kpi.icon}
                  </div>
                  <div style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontWeight: 700,
                    fontSize: 18,
                    color: '#0F2A44',
                    marginBottom: 8,
                  }}>
                    {kpi.title}
                  </div>
                  <div style={{
                    fontSize: 14,
                    color: '#64748B',
                    lineHeight: 1.5,
                  }}>
                    {kpi.desc}
                  </div>
                </motion.div>
              ))}
            </div>
            
            {/* ═══ GRILLE BÉNÉFICES — 2 COLONNES ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 22,
              marginBottom: 50,
            }} className="benefits-grid-2col">
              {[
                { 
                  title: 'Du temps retrouvé', 
                  desc: 'Pour ta famille, tes proches, tes clients importants — ou simplement pour respirer.',
                  iconBg: '#FFEDD5',
                  iconColor: '#EA580C',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <polyline points="12 6 12 12 16 14"/>
                    </svg>
                  )
                },
                { 
                  title: 'De la sérénité', 
                  desc: 'Moins de stress pour les devis, les relances, les messages et les oublis du quotidien.',
                  iconBg: '#DCFCE7',
                  iconColor: '#16A34A',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
                    </svg>
                  )
                },
                { 
                  title: 'Zéro lead qui dort', 
                  desc: 'Ton assistant t\'aide à répondre, relancer et suivre les demandes au bon moment.',
                  iconBg: '#DBEAFE',
                  iconColor: '#2563EB',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <circle cx="12" cy="12" r="6"/>
                      <circle cx="12" cy="12" r="2"/>
                    </svg>
                  )
                },
                { 
                  title: 'Une présence plus régulière', 
                  desc: 'Ton activité reste visible, organisée et mieux suivie, même quand tu es sur le terrain.',
                  iconBg: '#EDE9FE',
                  iconColor: '#7C3AED',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )
                },
                { 
                  title: 'Une image plus professionnelle', 
                  desc: 'Des réponses plus propres, des suivis plus clairs et une meilleure expérience pour tes clients.',
                  iconBg: '#FFEDD5',
                  iconColor: '#EA580C',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  )
                },
                { 
                  title: 'Tes informations au bon endroit', 
                  desc: 'Notes vocales, demandes, tâches, documents : tout peut être structuré dans ton Cockpit.',
                  iconBg: '#CCFBF1',
                  iconColor: '#0D9488',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/>
                      <line x1="12" y1="11" x2="12" y2="17"/>
                      <line x1="9" y1="14" x2="15" y2="14"/>
                    </svg>
                  )
                },
                { 
                  title: 'La vision, pas l\'exécution', 
                  desc: 'Tu pilotes ton entreprise au lieu de subir les petites tâches qui te prennent ton énergie.',
                  iconBg: '#DBEAFE',
                  iconColor: '#2563EB',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>
                    </svg>
                  )
                },
                { 
                  title: 'Une équipe qui peut grandir', 
                  desc: 'Tu démarres avec ton Super Assistant, puis tu ajoutes des agents IA spécialisés quand ton activité le demande.',
                  iconBg: '#DCFCE7',
                  iconColor: '#16A34A',
                  icon: (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 00-3-3.87"/>
                      <path d="M16 3.13a4 4 0 010 7.75"/>
                    </svg>
                  )
                },
              ].map((benefit, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.05 }}
                  style={{
                    background: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    borderRadius: 20,
                    padding: '26px 30px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 18,
                    boxShadow: '0 4px 20px rgba(15, 42, 68, 0.04)',
                    transition: 'all 0.2s ease',
                    cursor: 'default',
                  }}
                  whileHover={{ 
                    y: -3, 
                    borderColor: 'rgba(249, 115, 22, 0.3)',
                    boxShadow: '0 12px 35px rgba(15, 42, 68, 0.08)'
                  }}
                >
                  <div style={{
                    width: 48,
                    height: 48,
                    borderRadius: 12,
                    background: benefit.iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    color: benefit.iconColor,
                    transition: 'transform 0.2s ease',
                  }}>
                    {benefit.icon}
                  </div>
                  <div>
                    <div style={{
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontWeight: 700,
                      fontSize: 17,
                      color: '#0F2A44',
                      marginBottom: 6,
                    }}>
                      {benefit.title}
                    </div>
                    <div style={{
                      fontSize: 14,
                      color: '#64748B',
                      lineHeight: 1.55,
                    }}>
                      {benefit.desc}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
            
            {/* ═══ BLOC DIFFÉRENCIATION IA — CARTE PREMIUM ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: 'linear-gradient(135deg, #0B1F3A 0%, #1E3A5F 50%, #0F2A44 100%)',
                borderRadius: 28,
                padding: 'clamp(32px, 5vw, 48px)',
                marginBottom: 40,
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 30px 60px rgba(11, 31, 58, 0.4)',
              }}
            >
              {/* Grille subtile en fond */}
              <div style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `
                  linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
                  linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)
                `,
                backgroundSize: '40px 40px',
                pointerEvents: 'none',
              }} />
              
              {/* Glow orange subtil */}
              <div style={{
                position: 'absolute',
                top: '50%',
                right: '10%',
                width: 300,
                height: 300,
                background: 'radial-gradient(circle, rgba(249, 115, 22, 0.15) 0%, transparent 70%)',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }} />
              
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto',
                  gap: 40,
                  alignItems: 'center',
                }} className="ia-card-grid">
                  
                  {/* Colonne gauche - Contenu */}
                  <div>
                    {/* Badge interne */}
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                      background: 'rgba(249, 115, 22, 0.15)',
                      border: '1px solid rgba(249, 115, 22, 0.3)',
                      color: '#F97316',
                      padding: '8px 14px',
                      borderRadius: 999,
                      fontSize: 13,
                      fontWeight: 600,
                      marginBottom: 20,
                    }}>
                      <span style={{ fontSize: 14 }}>⚡</span>
                      Intelligence adaptée à chaque mission
                    </span>
                    
                    <h3 style={{
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontWeight: 800,
                      fontSize: 'clamp(28px, 4vw, 40px)',
                      color: '#FFFFFF',
                      marginBottom: 16,
                      lineHeight: 1.15,
                    }}>
                      La bonne IA, <span style={{ color: '#F97316' }}>au bon moment.</span>
                    </h3>
                    
                    <p style={{
                      fontSize: 'clamp(15px, 1.8vw, 17px)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      lineHeight: 1.65,
                      marginBottom: 24,
                      maxWidth: 560,
                    }}>
                      Chaque agent peut s'appuyer sur les meilleures intelligences disponibles — Claude, ChatGPT, Gemini — selon la mission à traiter : rédaction, analyse, organisation, stratégie ou suivi.
                    </p>
                    
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.08)',
                      borderRadius: 12,
                      padding: '16px 20px',
                      display: 'inline-block',
                    }}>
                      <p style={{
                        fontSize: 15,
                        color: '#FFFFFF',
                        margin: 0,
                        fontWeight: 500,
                      }}>
                        Tu n'as pas à choisir l'outil.<br />
                        <span style={{ color: '#F97316', fontWeight: 700 }}>L'agent utilise le plus adapté.</span>
                      </p>
                    </div>
                  </div>
                  
                  {/* Colonne droite - Capsules visuelles */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} className="ia-capsules">
                    {['Rédaction', 'Analyse', 'Organisation'].map((item, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 + i * 0.1 }}
                        style={{
                          background: 'rgba(255, 255, 255, 0.1)',
                          border: '1px solid rgba(255, 255, 255, 0.15)',
                          borderRadius: 12,
                          padding: '14px 24px',
                          color: '#FFFFFF',
                          fontSize: 15,
                          fontWeight: 600,
                          textAlign: 'center',
                          backdropFilter: 'blur(8px)',
                        }}
                      >
                        {item}
                      </motion.div>
                    ))}
                    
                    {/* Flèche */}
                    <div style={{ textAlign: 'center', padding: '8px 0' }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"/>
                        <polyline points="19 12 12 19 5 12"/>
                      </svg>
                    </div>
                    
                    {/* Destination */}
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.7 }}
                      style={{
                        background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                        borderRadius: 12,
                        padding: '16px 24px',
                        color: '#FFFFFF',
                        fontSize: 14,
                        fontWeight: 700,
                        textAlign: 'center',
                        boxShadow: '0 8px 24px rgba(249, 115, 22, 0.3)',
                      }}
                    >
                      Action dans ton Cockpit
                    </motion.div>
                  </div>
                </div>
              </div>
            </motion.div>
            
            {/* ═══ BANDEAU BAS DE TRANSITION ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: '#FFFFFF',
                border: '1px solid #E5E7EB',
                borderRadius: 18,
                padding: '22px 28px',
                textAlign: 'center',
              }}
            >
              <p style={{
                fontSize: 'clamp(15px, 2vw, 17px)',
                color: '#0F2A44',
                margin: 0,
                fontWeight: 500,
              }}>
                Maintenant que tu vois ce que tu gagnes, découvre comment les{' '}
                <span style={{ color: '#F97316', fontWeight: 700 }}>agents travaillent ensemble.</span>
              </p>
            </motion.div>
            
          </div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            BLOC 4 — CE QUE TU PEUX LUI DEMANDER (Démonstration concrète)
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: '#FFFFFF',
          padding: 'clamp(70px, 10vw, 110px) clamp(20px, 5vw, 40px)',
        }}>
          <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Badge haut */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: 'rgba(249, 115, 22, 0.10)',
                border: '1px solid rgba(249, 115, 22, 0.2)',
                color: '#F97316',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 700,
              }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Exemples concrets
              </span>
            </div>
            
            {/* Titre principal */}
            <h2 style={{
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(36px, 5vw, 60px)',
              lineHeight: 1.08,
              marginBottom: 24,
              color: '#0F2A44',
            }}>
              Tu lui demandes.<br />
              <span style={{ color: '#F97316' }}>Il t'aide à avancer.</span>
            </h2>
            
            {/* Sous-texte */}
            <p style={{
              textAlign: 'center',
              maxWidth: 760,
              margin: '0 auto 60px',
              fontSize: 'clamp(16px, 2vw, 20px)',
              lineHeight: 1.6,
              color: '#475569',
            }}>
              Une question, une note vocale, une idée, un client à relancer : ton Super Assistant IA t'aide à structurer, préparer et organiser tes actions dans ton Cockpit.
            </p>
            
            {/* ═══ LAYOUT PRINCIPAL — 2 COLONNES ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '45% 55%',
              gap: 32,
              marginBottom: 48,
            }} className="demo-layout-grid">
              
              {/* ═══ COLONNE GAUCHE — Exemples de demandes ═══ */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {[
                  {
                    title: 'Note vocale',
                    text: '"Résume ce que je viens de dire et crée les tâches à faire."',
                    sublabel: 'Idéal après un rendez-vous ou un chantier',
                    iconBg: '#DBEAFE',
                    iconColor: '#2563EB',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/>
                        <path d="M19 10v2a7 7 0 01-14 0v-2"/>
                        <line x1="12" y1="19" x2="12" y2="23"/>
                        <line x1="8" y1="23" x2="16" y2="23"/>
                      </svg>
                    )
                  },
                  {
                    title: 'Réponse client',
                    text: '"Prépare une réponse claire pour ce client qui demande un devis."',
                    sublabel: 'Pour répondre vite et proprement',
                    iconBg: '#FFEDD5',
                    iconColor: '#EA580C',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
                      </svg>
                    )
                  },
                  {
                    title: 'Organisation',
                    text: '"Classe mes priorités de la journée et rappelle-moi les urgences."',
                    sublabel: 'Pour éviter les oublis',
                    iconBg: '#DCFCE7',
                    iconColor: '#16A34A',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 11l3 3L22 4"/>
                        <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                      </svg>
                    )
                  },
                  {
                    title: 'Suivi commercial',
                    text: '"Relance les devis en attente et prépare un message adapté."',
                    sublabel: 'Selon la formule, l\'action peut être préparée ou déléguée',
                    iconBg: '#EDE9FE',
                    iconColor: '#7C3AED',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/>
                        <circle cx="12" cy="12" r="6"/>
                        <circle cx="12" cy="12" r="2"/>
                      </svg>
                    )
                  },
                  {
                    title: 'Contenu & visibilité',
                    text: '"Prépare un post pour présenter ce chantier terminé."',
                    sublabel: 'Avec les agents adaptés, le contenu peut être structuré plus loin',
                    iconBg: '#FCE7F3',
                    iconColor: '#DB2777',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                        <polyline points="17 8 12 3 7 8"/>
                        <line x1="12" y1="3" x2="12" y2="15"/>
                      </svg>
                    )
                  },
                ].map((card, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.08 }}
                    style={{
                      background: '#FFFFFF',
                      border: '1px solid #E5E7EB',
                      borderRadius: 18,
                      padding: 22,
                      display: 'flex',
                      gap: 16,
                      boxShadow: '0 4px 20px rgba(15, 42, 68, 0.05)',
                      transition: 'all 0.2s ease',
                      cursor: 'default',
                    }}
                    whileHover={{ 
                      y: -3, 
                      boxShadow: '0 12px 35px rgba(15, 42, 68, 0.1)',
                      borderColor: 'rgba(249, 115, 22, 0.25)'
                    }}
                  >
                    <div style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      background: card.iconBg,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      color: card.iconColor,
                    }}>
                      {card.icon}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontWeight: 700,
                        fontSize: 16,
                        color: '#0F2A44',
                        marginBottom: 6,
                      }}>
                        {card.title}
                      </div>
                      <div style={{
                        fontSize: 14,
                        color: '#334155',
                        lineHeight: 1.5,
                        marginBottom: 8,
                        fontStyle: 'italic',
                      }}>
                        {card.text}
                      </div>
                      <div style={{
                        fontSize: 12,
                        color: '#94A3B8',
                        fontWeight: 500,
                      }}>
                        {card.sublabel}
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
              
              {/* ═══ COLONNE DROITE — Interface Cockpit ═══ */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  borderRadius: 28,
                  padding: 28,
                  boxShadow: '0 25px 60px rgba(15, 42, 68, 0.1)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                {/* Glow subtil */}
                <div style={{
                  position: 'absolute',
                  top: -50,
                  right: -50,
                  width: 200,
                  height: 200,
                  background: 'radial-gradient(circle, rgba(249, 115, 22, 0.08) 0%, transparent 70%)',
                  pointerEvents: 'none',
                }} />
                
                {/* Header */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: 24,
                  paddingBottom: 16,
                  borderBottom: '1px solid #F1F5F9',
                }}>
                  <div>
                    <div style={{
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontWeight: 700,
                      fontSize: 18,
                      color: '#0F2A44',
                    }}>
                      Super Assistant IA
                    </div>
                    <div style={{ fontSize: 13, color: '#64748B' }}>
                      Disponible dans ton Cockpit
                    </div>
                  </div>
                  <span style={{
                    background: 'rgba(34, 197, 94, 0.15)',
                    color: '#16A34A',
                    padding: '6px 12px',
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                  }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#22C55E' }} />
                    Actif
                  </span>
                </div>
                
                {/* Zone de dialogue */}
                <div style={{
                  background: '#F8FAFC',
                  borderRadius: 16,
                  padding: 20,
                  marginBottom: 20,
                }}>
                  {/* Message utilisateur */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginBottom: 16,
                  }}>
                    <div style={{
                      background: '#0F2A44',
                      color: '#FFFFFF',
                      padding: '14px 18px',
                      borderRadius: '18px 18px 4px 18px',
                      maxWidth: '85%',
                      fontSize: 14,
                      lineHeight: 1.5,
                    }}>
                      "Je viens de finir le rendez-vous avec M. Dupont. Il veut refaire sa salle de bain. Fais-moi un résumé et prépare les prochaines étapes."
                    </div>
                  </div>
                  
                  {/* Réponse assistant */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                  }}>
                    <div style={{
                      background: '#FFFFFF',
                      border: '1px solid #E5E7EB',
                      padding: '14px 18px',
                      borderRadius: '18px 18px 18px 4px',
                      maxWidth: '85%',
                      fontSize: 14,
                      lineHeight: 1.6,
                      color: '#334155',
                    }}>
                      <strong style={{ color: '#0F2A44' }}>Résumé créé.</strong><br />
                      <span style={{ color: '#64748B' }}>Projet :</span> rénovation salle de bain.<br />
                      <span style={{ color: '#64748B' }}>Client :</span> M. Dupont.<br />
                      <span style={{ color: '#64748B' }}>À préparer :</span> devis, planning, choix matériaux.
                    </div>
                  </div>
                </div>
                
                {/* Zone Actions préparées */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: '#64748B',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    marginBottom: 12,
                  }}>
                    Actions préparées
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {[
                      { icon: '✓', label: 'Tâche créée', value: 'Préparer le devis', color: '#16A34A' },
                      { icon: '✓', label: 'Client ajouté au suivi', value: 'M. Dupont — projet salle de bain', color: '#16A34A' },
                      { icon: '✓', label: 'Note classée', value: 'Rendez-vous client', color: '#16A34A' },
                      { icon: '→', label: 'Prochaine étape proposée', value: 'Envoyer une demande de photos / dimensions', color: '#F97316' },
                    ].map((action, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.4 + i * 0.08 }}
                        style={{
                          background: '#FFFFFF',
                          border: '1px solid #F1F5F9',
                          borderRadius: 12,
                          padding: '12px 16px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 12,
                        }}
                      >
                        <div style={{
                          width: 28,
                          height: 28,
                          borderRadius: 8,
                          background: action.color === '#16A34A' ? 'rgba(34, 197, 94, 0.15)' : 'rgba(249, 115, 22, 0.15)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: action.color,
                          fontSize: 14,
                          fontWeight: 700,
                        }}>
                          {action.icon}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: '#94A3B8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>
                            {action.label}
                          </div>
                          <div style={{ fontSize: 14, color: '#0F2A44', fontWeight: 500 }}>
                            {action.value}
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
                
                {/* Bandeau bas */}
                <div style={{
                  background: 'rgba(15, 42, 68, 0.04)',
                  borderRadius: 12,
                  padding: '14px 18px',
                  textAlign: 'center',
                }}>
                  <p style={{
                    fontSize: 13,
                    color: '#475569',
                    margin: 0,
                    fontWeight: 500,
                  }}>
                    Tu restes maître. <span style={{ color: '#F97316', fontWeight: 600 }}>L'assistant prépare, structure et t'aide à décider.</span>
                  </p>
                </div>
              </motion.div>
            </div>
            
            {/* ═══ BANDEAU BAS DE SECTION ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: 'linear-gradient(135deg, rgba(15, 42, 68, 0.03) 0%, rgba(15, 42, 68, 0.06) 100%)',
                border: '1px solid #E5E7EB',
                borderRadius: 22,
                padding: 'clamp(24px, 4vw, 32px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 32,
              }}
              className="demo-bottom-banner"
            >
              <div style={{ flex: 1 }}>
                <div style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 'clamp(20px, 2.5vw, 26px)',
                  color: '#0F2A44',
                  marginBottom: 8,
                }}>
                  Un assistant qui comprend ton métier.
                </div>
                <p style={{
                  fontSize: 'clamp(14px, 1.5vw, 16px)',
                  color: '#64748B',
                  margin: 0,
                  lineHeight: 1.5,
                }}>
                  Il ne se contente pas de répondre. Il t'aide à transformer tes idées, tes notes et tes demandes en actions concrètes dans ton Cockpit.
                </p>
              </div>
              
              <div style={{
                display: 'flex',
                gap: 12,
                flexWrap: 'wrap',
                justifyContent: 'flex-end',
              }} className="demo-pillars">
                {['Écrit', 'Vocal', 'Organisation', 'Suivi'].map((pillar, i) => (
                  <span key={i} style={{
                    background: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    padding: '10px 18px',
                    borderRadius: 12,
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#0F2A44',
                    boxShadow: '0 2px 8px rgba(15, 42, 68, 0.06)',
                  }}>
                    {pillar}
                  </span>
                ))}
              </div>
            </motion.div>
            
          </div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            BLOC 5 — LES AGENTS IA SPÉCIALISÉS
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: '#FFFDF9',
          padding: 'clamp(70px, 10vw, 120px) clamp(20px, 5vw, 40px)',
        }}>
          <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Badge haut */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: 'rgba(249, 115, 22, 0.10)',
                border: '1px solid rgba(249, 115, 22, 0.2)',
                color: '#F97316',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 700,
              }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Agents IA spécialisés
              </span>
            </div>
            
            {/* Titre principal */}
            <h2 style={{
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(34px, 5vw, 62px)',
              lineHeight: 1.05,
              marginBottom: 24,
              color: '#0F2A44',
              maxWidth: 900,
              margin: '0 auto 24px',
            }}>
              Une équipe IA qui grandit<br />
              <span style={{ color: '#F97316' }}>avec ton entreprise.</span>
            </h2>
            
            {/* Sous-texte */}
            <p style={{
              textAlign: 'center',
              maxWidth: 820,
              margin: '0 auto 64px',
              fontSize: 'clamp(16px, 2vw, 20px)',
              lineHeight: 1.6,
              color: '#475569',
            }}>
              Tu commences avec ton Super Assistant IA.<br />
              Selon ta formule, tu peux ajouter des agents spécialisés pour renforcer ton commercial, ton administratif, ton service client, ton marketing ou ton organisation.
            </p>
            
            {/* ═══ BLOC DE PROGRESSION — 3 NIVEAUX ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 24,
              marginBottom: 32,
            }} className="progression-grid">
              
              {/* Carte 1 — Pro */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0 }}
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  borderRadius: 24,
                  padding: 28,
                  position: 'relative',
                  boxShadow: '0 8px 30px rgba(15, 42, 68, 0.06)',
                }}
              >
                <span style={{
                  position: 'absolute',
                  top: -12,
                  left: 24,
                  background: '#DBEAFE',
                  color: '#2563EB',
                  padding: '6px 14px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                }}>
                  Formule Pro
                </span>
                
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: 16,
                  background: '#DBEAFE',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 20,
                  marginTop: 8,
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 22,
                  color: '#0F2A44',
                  marginBottom: 12,
                }}>
                  Super Assistant IA
                </h3>
                
                <p style={{
                  fontSize: 15,
                  color: '#64748B',
                  lineHeight: 1.55,
                  marginBottom: 20,
                }}>
                  Ton point d'entrée unique. Tu écris, tu parles, il comprend et t'aide à structurer ton quotidien.
                </p>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {['Notes vocales', 'Réponses préparées', 'Organisation', 'Actions dans le Cockpit'].map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#334155' }}>
                      <span style={{ color: '#2563EB', fontWeight: 600 }}>✓</span>
                      {item}
                    </div>
                  ))}
                </div>
              </motion.div>
              
              {/* Carte 2 — Business (mise en avant) */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                style={{
                  background: '#FFFFFF',
                  border: '2px solid #F97316',
                  borderRadius: 24,
                  padding: 28,
                  position: 'relative',
                  boxShadow: '0 12px 40px rgba(249, 115, 22, 0.15)',
                  transform: 'scale(1.02)',
                }}
              >
                <span style={{
                  position: 'absolute',
                  top: -12,
                  left: 24,
                  background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                  color: '#FFFFFF',
                  padding: '6px 14px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                }}>
                  Formule Business
                </span>
                
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: 16,
                  background: '#FFEDD5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 20,
                  marginTop: 8,
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 00-3-3.87"/>
                    <path d="M16 3.13a4 4 0 010 7.75"/>
                  </svg>
                </div>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 22,
                  color: '#0F2A44',
                  marginBottom: 12,
                }}>
                  + 4 agents IA
                </h3>
                
                <p style={{
                  fontSize: 15,
                  color: '#64748B',
                  lineHeight: 1.55,
                  marginBottom: 20,
                }}>
                  Une équipe spécialisée pour t'aider sur les missions essentielles de ton activité.
                </p>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {['Commercial', 'Administratif', 'Service client', 'Organisation / chantier'].map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#334155' }}>
                      <span style={{ color: '#F97316', fontWeight: 600 }}>✓</span>
                      {item}
                    </div>
                  ))}
                </div>
              </motion.div>
              
              {/* Carte 3 — Premium */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                style={{
                  background: 'linear-gradient(135deg, #0F2A44 0%, #1E3A5F 100%)',
                  border: '1px solid #1E3A5F',
                  borderRadius: 24,
                  padding: 28,
                  position: 'relative',
                  boxShadow: '0 12px 40px rgba(15, 42, 68, 0.25)',
                  color: '#FFFFFF',
                }}
              >
                <span style={{
                  position: 'absolute',
                  top: -12,
                  left: 24,
                  background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                  color: '#FFFFFF',
                  padding: '6px 14px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                }}>
                  ⭐ Formule Premium
                </span>
                
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: 16,
                  background: 'rgba(249, 115, 22, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 20,
                  marginTop: 8,
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                  </svg>
                </div>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 22,
                  color: '#FFFFFF',
                  marginBottom: 12,
                }}>
                  + 12 agents IA
                </h3>
                
                <p style={{
                  fontSize: 15,
                  color: 'rgba(255,255,255,0.8)',
                  lineHeight: 1.55,
                  marginBottom: 20,
                }}>
                  La Dream Team complète pour structurer, automatiser et mieux piloter ton entreprise.
                </p>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {['Marketing', 'Finance', 'Réputation', 'Logistique', 'Création', 'Web'].map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'rgba(255,255,255,0.9)' }}>
                      <span style={{ color: '#F97316', fontWeight: 600 }}>✓</span>
                      {item}
                    </div>
                  ))}
                </div>
              </motion.div>
            </div>
            
            {/* Note sous les 3 cartes */}
            <div style={{
              background: 'rgba(30, 58, 95, 0.04)',
              borderRadius: 18,
              padding: 22,
              maxWidth: 820,
              margin: '0 auto 80px',
              textAlign: 'center',
            }}>
              <p style={{
                fontSize: 16,
                color: '#0F2A44',
                margin: 0,
                fontWeight: 500,
                lineHeight: 1.5,
              }}>
                Tu avances niveau par niveau.<br />
                <span style={{ color: '#64748B' }}>Aucune usine à gaz. Tu ajoutes de la puissance quand tu en as besoin.</span>
              </p>
            </div>
            
            {/* ═══ GRILLE DES 12 AGENTS IA ═══ */}
            <div style={{ marginBottom: 48 }}>
              <h3 style={{
                textAlign: 'center',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: 'clamp(22px, 3vw, 28px)',
                color: '#0F2A44',
                marginBottom: 12,
              }}>
                Les agents disponibles dans l'écosystème
              </h3>
              <p style={{
                textAlign: 'center',
                fontSize: 16,
                color: '#64748B',
                marginBottom: 8,
                maxWidth: 700,
                margin: '0 auto 12px',
              }}>
                Chaque agent a un rôle précis. Ensemble, ils renforcent ton organisation dans le Cockpit.
              </p>
              <p style={{
                textAlign: 'center',
                fontSize: 13,
                color: '#94A3B8',
                fontWeight: 500,
                marginBottom: 40,
              }}>
                Disponibilité selon formule Business ou Premium.
              </p>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 20,
              }} className="agents-grid-12">
                {[
                  { name: 'Agent Commercial', desc: 'Aide à préparer les devis, relances, messages prospects et suivis commerciaux.', cat: 'Vente', iconBg: '#FFEDD5', iconColor: '#EA580C', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg> },
                  { name: 'Agent Administratif', desc: 'Aide à classer, structurer, préparer des documents et organiser les tâches.', cat: 'Organisation', iconBg: '#DBEAFE', iconColor: '#2563EB', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg> },
                  { name: 'Agent Service Client', desc: 'Aide à préparer des réponses claires aux demandes clients et messages entrants.', cat: 'Clients', iconBg: '#DCFCE7', iconColor: '#16A34A', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 18v-6a9 9 0 0118 0v6"/><path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z"/></svg> },
                  { name: 'Agent Chantier', desc: 'Aide à suivre les étapes, priorités, rendez-vous et informations terrain.', cat: 'Terrain', iconBg: '#FEF3C7', iconColor: '#D97706', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"/><path d="M18 2l4 4-4 4"/><path d="M2 6h1.9c1.5 0 2.9.9 3.6 2.2"/><path d="M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8"/></svg> },
                  { name: 'Agent Community Manager', desc: 'Aide à préparer des publications, réponses et contenus pour les réseaux sociaux.', cat: 'Réseaux', iconBg: '#FCE7F3', iconColor: '#DB2777', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg> },
                  { name: 'Agent Marketing', desc: 'Aide à structurer tes campagnes, messages, offres et actions de visibilité.', cat: 'Croissance', iconBg: '#EDE9FE', iconColor: '#7C3AED', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg> },
                  { name: 'Agent Webmaster', desc: 'Aide à organiser les contenus, mises à jour, pages, boutique et visibilité du site.', cat: 'Web', iconBg: '#CCFBF1', iconColor: '#0D9488', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> },
                  { name: 'Agent Créatif', desc: 'Aide à préparer des idées de visuels, supports, textes et contenus de marque.', cat: 'Création', iconBg: '#FFEDD5', iconColor: '#EA580C', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> },
                  { name: 'Agent Réputation', desc: 'Aide à suivre les avis, commentaires, réponses et signaux importants.', cat: 'Image', iconBg: '#DCFCE7', iconColor: '#16A34A', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
                  { name: 'Agent Financier', desc: 'Aide à suivre les factures, alertes, marges, paiements et points de vigilance.', cat: 'Finance', iconBg: '#DBEAFE', iconColor: '#2563EB', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg> },
                  { name: 'Agent Juridique', desc: 'Aide à préparer, relire et organiser des éléments contractuels simples.', cat: 'Cadre', iconBg: '#EDE9FE', iconColor: '#7C3AED', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 3v18"/><path d="M3 12l4-4 4 4"/><path d="M21 12l-4-4-4 4"/><path d="M3 12h6"/><path d="M15 12h6"/></svg>, note: 'Ne remplace pas un conseil juridique professionnel.' },
                  { name: 'Agent Logistique', desc: 'Aide à organiser commandes, livraisons, stocks, fournisseurs et suivis.', cat: 'Opérations', iconBg: '#FFEDD5', iconColor: '#EA580C', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> },
                ].map((agent, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.04 }}
                    style={{
                      background: '#FFFFFF',
                      border: '1px solid #E5E7EB',
                      borderRadius: 20,
                      padding: 24,
                      boxShadow: '0 4px 20px rgba(15, 42, 68, 0.04)',
                      transition: 'all 0.2s ease',
                      cursor: 'default',
                    }}
                    whileHover={{ 
                      y: -3, 
                      borderColor: 'rgba(249, 115, 22, 0.3)',
                      boxShadow: '0 12px 35px rgba(15, 42, 68, 0.08)'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 12 }}>
                      <div style={{
                        width: 48,
                        height: 48,
                        borderRadius: 12,
                        background: agent.iconBg,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        color: agent.iconColor,
                        transition: 'transform 0.2s ease',
                      }}>
                        {agent.icon}
                      </div>
                      <div>
                        <span style={{
                          fontSize: 10,
                          fontWeight: 700,
                          color: agent.iconColor,
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                        }}>
                          {agent.cat}
                        </span>
                        <div style={{
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 700,
                          fontSize: 15,
                          color: '#0F2A44',
                          marginTop: 2,
                        }}>
                          {agent.name}
                        </div>
                      </div>
                    </div>
                    <p style={{
                      fontSize: 13,
                      color: '#64748B',
                      lineHeight: 1.5,
                      margin: 0,
                    }}>
                      {agent.desc}
                    </p>
                    {agent.note && (
                      <p style={{
                        fontSize: 11,
                        color: '#94A3B8',
                        fontStyle: 'italic',
                        marginTop: 8,
                        marginBottom: 0,
                      }}>
                        {agent.note}
                      </p>
                    )}
                  </motion.div>
                ))}
              </div>
            </div>
            
            {/* ═══ BLOC PREMIUM — MEILLEURE IA SELON LA MISSION ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: 'linear-gradient(135deg, #0B1F3A 0%, #1E3A5F 50%, #0F2A44 100%)',
                borderRadius: 28,
                padding: 'clamp(32px, 5vw, 48px)',
                marginBottom: 40,
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 30px 60px rgba(11, 31, 58, 0.4)',
              }}
            >
              {/* Grille subtile */}
              <div style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `
                  linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                  linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
                `,
                backgroundSize: '50px 50px',
                pointerEvents: 'none',
              }} />
              
              {/* Glow orange */}
              <div style={{
                position: 'absolute',
                top: '50%',
                right: '5%',
                width: 350,
                height: 350,
                background: 'radial-gradient(circle, rgba(249, 115, 22, 0.12) 0%, transparent 70%)',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }} />
              
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto',
                  gap: 48,
                  alignItems: 'center',
                }} className="ia-mission-grid">
                  
                  {/* Colonne gauche */}
                  <div>
                    <h3 style={{
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontWeight: 800,
                      fontSize: 'clamp(24px, 3.5vw, 36px)',
                      color: '#FFFFFF',
                      marginBottom: 16,
                      lineHeight: 1.2,
                    }}>
                      Chaque agent utilise <span style={{ color: '#F97316' }}>l'intelligence la plus adaptée.</span>
                    </h3>
                    
                    <p style={{
                      fontSize: 'clamp(15px, 1.8vw, 17px)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      lineHeight: 1.65,
                      marginBottom: 24,
                      maxWidth: 560,
                    }}>
                      Selon la mission, les agents peuvent s'appuyer sur les meilleures IA disponibles — Claude, ChatGPT, Gemini — pour rédiger, analyser, organiser ou structurer tes actions.
                    </p>
                    
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.08)',
                      borderRadius: 14,
                      padding: '18px 24px',
                      display: 'inline-block',
                    }}>
                      <p style={{
                        fontSize: 16,
                        color: '#FFFFFF',
                        margin: 0,
                        fontWeight: 500,
                        lineHeight: 1.5,
                      }}>
                        Tu ne choisis pas un outil.<br />
                        <span style={{ color: '#F97316', fontWeight: 700 }}>Tu utilises le bon agent, au bon moment.</span>
                      </p>
                    </div>
                  </div>
                  
                  {/* Colonne droite — Capsules */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center' }} className="mission-capsules">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                      {['Rédaction', 'Analyse', 'Organisation', 'Stratégie'].map((item, i) => (
                        <motion.div
                          key={i}
                          initial={{ opacity: 0, scale: 0.9 }}
                          whileInView={{ opacity: 1, scale: 1 }}
                          viewport={{ once: true }}
                          transition={{ delay: 0.3 + i * 0.08 }}
                          style={{
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            borderRadius: 12,
                            padding: '14px 20px',
                            color: '#FFFFFF',
                            fontSize: 14,
                            fontWeight: 600,
                            textAlign: 'center',
                            backdropFilter: 'blur(8px)',
                          }}
                        >
                          {item}
                        </motion.div>
                      ))}
                    </div>
                    
                    {/* Flèche */}
                    <div style={{ padding: '8px 0' }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"/>
                        <polyline points="19 12 12 19 5 12"/>
                      </svg>
                    </div>
                    
                    {/* Destination */}
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.7 }}
                      style={{
                        background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                        borderRadius: 14,
                        padding: '16px 32px',
                        color: '#FFFFFF',
                        fontSize: 15,
                        fontWeight: 700,
                        textAlign: 'center',
                        boxShadow: '0 8px 24px rgba(249, 115, 22, 0.3)',
                      }}
                    >
                      Action dans ton Cockpit
                    </motion.div>
                  </div>
                </div>
              </div>
            </motion.div>
            
            {/* ═══ BANDEAU DE TRANSITION ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: '#FFFFFF',
                border: '1px solid #E5E7EB',
                borderRadius: 18,
                padding: 24,
                textAlign: 'center',
              }}
            >
              <p style={{
                fontSize: 'clamp(15px, 2vw, 17px)',
                color: '#0F2A44',
                margin: 0,
                fontWeight: 500,
              }}>
                Maintenant que tu connais les agents, regarde comment tout reste centralisé dans ton{' '}
                <span style={{ color: '#F97316', fontWeight: 700 }}>Cockpit.</span>
              </p>
            </motion.div>
            
          </div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            BLOC 6 — TOUT RESTE CENTRALISÉ DANS TON COCKPIT
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: '#FFFFFF',
          padding: 'clamp(70px, 10vw, 120px) clamp(20px, 5vw, 40px)',
        }}>
          <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Badge haut */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: 'rgba(249, 115, 22, 0.10)',
                border: '1px solid rgba(249, 115, 22, 0.2)',
                color: '#F97316',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 700,
              }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Cockpit centralisé
              </span>
            </div>
            
            {/* Titre principal */}
            <h2 style={{
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(32px, 5vw, 60px)',
              lineHeight: 1.05,
              marginBottom: 24,
              color: '#0F2A44',
              maxWidth: 950,
              margin: '0 auto 24px',
            }}>
              Pas une IA posée à côté.<br />
              <span style={{ color: '#F97316' }}>Une IA intégrée à ton Cockpit.</span>
            </h2>
            
            {/* Sous-texte */}
            <p style={{
              textAlign: 'center',
              maxWidth: 860,
              margin: '0 auto 64px',
              fontSize: 'clamp(16px, 2vw, 20px)',
              lineHeight: 1.6,
              color: '#475569',
            }}>
              Ton Super Assistant et tes agents IA travaillent dans le même espace que tes clients, tes tâches, tes devis, tes messages, ton site, ta boutique et tes contenus.
            </p>
            
            {/* ═══ LAYOUT PRINCIPAL — DOUBLE COLONNE ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '58% 42%',
              gap: 36,
              alignItems: 'center',
              marginBottom: 56,
            }} className="cockpit-layout-grid">
              
              {/* ═══ COLONNE GAUCHE — GRANDE CARTE INTERFACE COCKPIT ═══ */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 30,
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 25px 70px rgba(15, 42, 68, 0.10)',
                  padding: 28,
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                {/* Header de la carte */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: 24,
                  paddingBottom: 20,
                  borderBottom: '1px solid #F1F5F9',
                }}>
                  <div>
                    <div style={{
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontWeight: 700,
                      fontSize: 18,
                      color: '#0F2A44',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                    }}>
                      <div style={{
                        width: 32,
                        height: 32,
                        borderRadius: 8,
                        background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2">
                          <rect x="3" y="3" width="18" height="18" rx="2"/>
                          <path d="M3 9h18"/>
                          <path d="M9 21V9"/>
                        </svg>
                      </div>
                      Abracada Cockpit
                    </div>
                    <div style={{ fontSize: 13, color: '#64748B', marginTop: 4, marginLeft: 42 }}>
                      Assistant IA connecté
                    </div>
                  </div>
                  <span style={{
                    background: 'rgba(34, 197, 94, 0.15)',
                    color: '#16A34A',
                    padding: '6px 14px',
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                  }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#22C55E' }} />
                    En ligne
                  </span>
                </div>
                
                {/* Zone centrale — grille modules */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: 14,
                  marginBottom: 24,
                }} className="cockpit-modules-grid">
                  {[
                    { name: 'Clients', status: '2 demandes à traiter', iconBg: '#FFEDD5', iconColor: '#EA580C', hasAlert: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg> },
                    { name: 'Devis', status: '1 devis préparé', iconBg: '#DBEAFE', iconColor: '#2563EB', hasCheck: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
                    { name: 'Tâches', status: '4 actions créées', iconBg: '#DCFCE7', iconColor: '#16A34A', hasCheck: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg> },
                    { name: 'Messages', status: 'Réponse suggérée', iconBg: '#EDE9FE', iconColor: '#7C3AED', hasCheck: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg> },
                    { name: 'Documents', status: 'Note classée', iconBg: '#CCFBF1', iconColor: '#0D9488', hasCheck: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg> },
                    { name: 'Boutique', status: 'Produit à vérifier', iconBg: '#FCE7F3', iconColor: '#DB2777', hasAlert: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> },
                    { name: 'Site internet', status: 'Contenu prêt', iconBg: '#DBEAFE', iconColor: '#2563EB', hasCheck: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> },
                    { name: 'Marketing', status: 'Post proposé', iconBg: '#FFEDD5', iconColor: '#EA580C', hasCheck: true, icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg> },
                  ].map((mod, i) => (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.1 + i * 0.05 }}
                      style={{
                        background: '#F8FAFC',
                        borderRadius: 16,
                        padding: '16px 14px',
                        border: '1px solid #F1F5F9',
                        transition: 'all 0.2s ease',
                        cursor: 'default',
                      }}
                      whileHover={{ 
                        borderColor: 'rgba(249, 115, 22, 0.25)',
                        background: '#FFFFFF'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                        <div style={{
                          width: 36,
                          height: 36,
                          borderRadius: 10,
                          background: mod.iconBg,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: mod.iconColor,
                        }}>
                          {mod.icon}
                        </div>
                        {mod.hasCheck && (
                          <span style={{ width: 16, height: 16, borderRadius: '50%', background: '#DCFCE7', color: '#16A34A', fontSize: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 'auto' }}>✓</span>
                        )}
                        {mod.hasAlert && (
                          <span style={{ width: 16, height: 16, borderRadius: '50%', background: '#FFEDD5', color: '#EA580C', fontSize: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 'auto' }}>!</span>
                        )}
                      </div>
                      <div style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: '#0F2A44',
                        marginBottom: 4,
                      }}>
                        {mod.name}
                      </div>
                      <div style={{
                        fontSize: 11,
                        color: '#64748B',
                        lineHeight: 1.4,
                      }}>
                        {mod.status}
                      </div>
                    </motion.div>
                  ))}
                </div>
                
                {/* Zone bas — Assistant IA */}
                <div style={{
                  background: 'linear-gradient(135deg, #0F2A44 0%, #1E3A5F 100%)',
                  borderRadius: 16,
                  padding: '16px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 16,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      background: 'rgba(249, 115, 22, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2">
                        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                      </svg>
                    </div>
                    <p style={{
                      fontSize: 13,
                      color: '#FFFFFF',
                      margin: 0,
                      lineHeight: 1.4,
                    }}>
                      "J'ai structuré les demandes du jour et préparé les prochaines actions."
                    </p>
                  </div>
                  <button style={{
                    background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                    border: 'none',
                    borderRadius: 10,
                    padding: '10px 18px',
                    color: '#FFFFFF',
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.2s ease',
                  }}>
                    Voir les actions
                  </button>
                </div>
              </motion.div>
              
              {/* ═══ COLONNE DROITE — 4 CARTES EXPLICATION ═══ */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {[
                  {
                    title: 'Tout arrive au bon endroit',
                    desc: 'Notes vocales, demandes clients, idées, messages : ton assistant t\'aide à les transformer en actions dans ton Cockpit.',
                    iconBg: '#FFEDD5',
                    iconColor: '#EA580C',
                    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/></svg>
                  },
                  {
                    title: 'Les agents restent connectés',
                    desc: 'Selon ta formule, les agents IA travaillent autour des mêmes informations, sans créer un nouvel outil à gérer.',
                    iconBg: '#DBEAFE',
                    iconColor: '#2563EB',
                    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v6m0 6v10"/><path d="M21 12h-6m-6 0H1"/><path d="M18.36 5.64l-4.24 4.24m-4.24 4.24l-4.24 4.24"/><path d="M5.64 5.64l4.24 4.24m4.24 4.24l4.24 4.24"/></svg>
                  },
                  {
                    title: 'Tu gardes la vision globale',
                    desc: 'Clients, tâches, devis, contenus et suivi restent visibles dans un seul espace.',
                    iconBg: '#EDE9FE',
                    iconColor: '#7C3AED',
                    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  },
                  {
                    title: 'Tu restes décisionnaire',
                    desc: 'L\'IA prépare, organise et suggère. Tu gardes le contrôle sur ce qui compte.',
                    iconBg: '#DCFCE7',
                    iconColor: '#16A34A',
                    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                  },
                ].map((card, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 + i * 0.08 }}
                    style={{
                      background: '#FFFFFF',
                      border: '1px solid #E5E7EB',
                      borderRadius: 20,
                      padding: 24,
                      display: 'flex',
                      gap: 16,
                      boxShadow: '0 4px 20px rgba(15, 42, 68, 0.04)',
                      transition: 'all 0.2s ease',
                      cursor: 'default',
                    }}
                    whileHover={{ 
                      y: -3, 
                      borderColor: 'rgba(249, 115, 22, 0.25)',
                      boxShadow: '0 12px 35px rgba(15, 42, 68, 0.08)'
                    }}
                  >
                    <div style={{
                      width: 48,
                      height: 48,
                      borderRadius: 14,
                      background: card.iconBg,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      color: card.iconColor,
                    }}>
                      {card.icon}
                    </div>
                    <div>
                      <div style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontWeight: 700,
                        fontSize: 16,
                        color: '#0F2A44',
                        marginBottom: 6,
                      }}>
                        {card.title}
                      </div>
                      <p style={{
                        fontSize: 14,
                        color: '#64748B',
                        lineHeight: 1.55,
                        margin: 0,
                      }}>
                        {card.desc}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
            
            {/* ═══ BANDEAU BAS — MESSAGE FORT ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: 'linear-gradient(135deg, #0B1F3A 0%, #1E3A5F 50%, #0F2A44 100%)',
                borderRadius: 28,
                padding: 'clamp(32px, 5vw, 48px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 30,
                position: 'relative',
                overflow: 'hidden',
              }}
              className="cockpit-bottom-banner"
            >
              {/* Grille subtile */}
              <div style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `
                  linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                  linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
                `,
                backgroundSize: '40px 40px',
                pointerEvents: 'none',
              }} />
              
              <div style={{ position: 'relative', zIndex: 1, flex: 1 }}>
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 'clamp(22px, 3vw, 32px)',
                  color: '#FFFFFF',
                  marginBottom: 12,
                  lineHeight: 1.2,
                }}>
                  Un seul Cockpit.<br />
                  <span style={{ color: '#F97316' }}>Un assistant. Des agents quand tu en as besoin.</span>
                </h3>
                <p style={{
                  fontSize: 'clamp(14px, 1.5vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.75)',
                  margin: 0,
                  lineHeight: 1.5,
                }}>
                  Tout reste connecté, organisé et pilotable depuis le même espace.
                </p>
              </div>
              
              <div style={{
                display: 'flex',
                gap: 12,
                flexWrap: 'wrap',
                position: 'relative',
                zIndex: 1,
              }} className="cockpit-pillars">
                {['Clients', 'Tâches', 'Devis', 'Messages'].map((pillar, i) => (
                  <span key={i} style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    padding: '10px 20px',
                    borderRadius: 999,
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#FFFFFF',
                  }}>
                    {pillar}
                  </span>
                ))}
              </div>
            </motion.div>
            
          </div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            BLOC 7 — COMPARAISON HONNÊTE (Avant / Après)
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: '#FFFDF9',
          padding: 'clamp(70px, 10vw, 120px) clamp(20px, 5vw, 40px)',
        }}>
          <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Badge haut */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: 'rgba(249, 115, 22, 0.10)',
                border: '1px solid rgba(249, 115, 22, 0.2)',
                color: '#F97316',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 700,
              }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Avant / Après
              </span>
            </div>
            
            {/* Titre principal */}
            <h2 style={{
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(32px, 5vw, 60px)',
              lineHeight: 1.05,
              marginBottom: 24,
              color: '#0F2A44',
              maxWidth: 900,
              margin: '0 auto 24px',
            }}>
              Moins de dispersion.<br />
              <span style={{ color: '#F97316' }}>Plus de contrôle.</span>
            </h2>
            
            {/* Sous-texte */}
            <p style={{
              textAlign: 'center',
              maxWidth: 780,
              margin: '0 auto 64px',
              fontSize: 'clamp(16px, 2vw, 20px)',
              lineHeight: 1.6,
              color: '#475569',
            }}>
              Abracada ne remplace pas ton métier.<br />
              Il t'aide à organiser ce qui te prend du temps, te fatigue et te fait perdre des opportunités.
            </p>
            
            {/* ═══ COMPARAISON PRINCIPALE — 2 GRANDES CARTES ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 32,
              marginBottom: 40,
            }} className="comparison-grid">
              
              {/* CARTE GAUCHE — SANS ABRACADA */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  borderRadius: 28,
                  padding: 'clamp(28px, 4vw, 40px)',
                  boxShadow: '0 12px 40px rgba(15, 42, 68, 0.06)',
                  transition: 'all 0.2s ease',
                }}
                whileHover={{ y: -4, boxShadow: '0 20px 50px rgba(15, 42, 68, 0.10)' }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  marginBottom: 24,
                  paddingBottom: 20,
                  borderBottom: '1px solid #F1F5F9',
                }}>
                  <div style={{
                    width: 48,
                    height: 48,
                    borderRadius: 14,
                    background: '#FEF2F2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="15" y1="9" x2="9" y2="15"/>
                      <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                  </div>
                  <div>
                    <h3 style={{
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontWeight: 800,
                      fontSize: 22,
                      color: '#0F2A44',
                      margin: 0,
                    }}>
                      Sans Abracada
                    </h3>
                    <p style={{ fontSize: 14, color: '#64748B', margin: '4px 0 0' }}>
                      Tout repose sur toi.
                    </p>
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {[
                    { title: 'Messages dispersés', desc: 'WhatsApp, mails, appels, notes… tout arrive partout.' },
                    { title: 'Relances oubliées', desc: 'Les devis, prospects et demandes restent parfois sans suivi.' },
                    { title: 'Charge mentale permanente', desc: 'Tu dois penser aux clients, aux chantiers, aux réponses, aux tâches.' },
                    { title: 'Outils séparés', desc: 'Site, boutique, CRM, documents, réseaux sociaux : rien ne parle vraiment ensemble.' },
                    { title: 'Temps perdu à retrouver l\'information', desc: 'Tu sais que l\'info existe, mais tu ne sais plus où elle est.' },
                    { title: 'Difficile de déléguer proprement', desc: 'Tu dois expliquer, répéter, contrôler et reprendre derrière.' },
                  ].map((item, i) => (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.1 + i * 0.05 }}
                      style={{
                        display: 'flex',
                        gap: 14,
                        padding: '14px 16px',
                        background: '#FAFAFA',
                        borderRadius: 14,
                        border: '1px solid #F1F5F9',
                      }}
                    >
                      <span style={{
                        width: 24,
                        height: 24,
                        borderRadius: 8,
                        background: '#FEE2E2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        color: '#DC2626',
                        fontSize: 12,
                        fontWeight: 700,
                      }}>
                        ✕
                      </span>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: '#0F2A44', marginBottom: 4 }}>
                          {item.title}
                        </div>
                        <div style={{ fontSize: 13, color: '#64748B', lineHeight: 1.45 }}>
                          {item.desc}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
              
              {/* CARTE DROITE — AVEC ABRACADA */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                style={{
                  background: 'linear-gradient(135deg, #0B1F3A 0%, #1E3A5F 50%, #0F2A44 100%)',
                  border: '2px solid #F97316',
                  borderRadius: 28,
                  padding: 'clamp(28px, 4vw, 40px)',
                  boxShadow: '0 20px 60px rgba(15, 42, 68, 0.25)',
                  color: '#FFFFFF',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.2s ease',
                }}
                whileHover={{ y: -4, boxShadow: '0 28px 70px rgba(15, 42, 68, 0.35)' }}
              >
                {/* Grille subtile */}
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  backgroundImage: `
                    linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
                  `,
                  backgroundSize: '30px 30px',
                  pointerEvents: 'none',
                }} />
                
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    marginBottom: 24,
                    paddingBottom: 20,
                    borderBottom: '1px solid rgba(255,255,255,0.15)',
                  }}>
                    <div style={{
                      width: 48,
                      height: 48,
                      borderRadius: 14,
                      background: 'rgba(249, 115, 22, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                        <polyline points="22 4 12 14.01 9 11.01"/>
                      </svg>
                    </div>
                    <div>
                      <h3 style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontWeight: 800,
                        fontSize: 22,
                        color: '#FFFFFF',
                        margin: 0,
                      }}>
                        Avec Abracada
                      </h3>
                      <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', margin: '4px 0 0' }}>
                        Ton organisation devient intelligente.
                      </p>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {[
                      { title: 'Un Cockpit centralisé', desc: 'Clients, tâches, messages, devis, documents et contenus au même endroit.' },
                      { title: 'Un Super Assistant intégré', desc: 'Tu écris ou tu parles, il t\'aide à structurer et préparer les actions.' },
                      { title: 'Des agents selon ta formule', desc: 'Tu ajoutes de la puissance uniquement quand tu en as besoin.' },
                      { title: 'Des suivis plus clairs', desc: 'Les demandes deviennent des actions visibles et organisées.' },
                      { title: 'Moins d\'oublis', desc: 'Les informations importantes ne restent plus seulement dans ta tête.' },
                      { title: 'Tu gardes le contrôle', desc: 'L\'IA aide, prépare, organise. Tu décides.' },
                    ].map((item, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 + i * 0.05 }}
                        style={{
                          display: 'flex',
                          gap: 14,
                          padding: '14px 16px',
                          background: 'rgba(255,255,255,0.08)',
                          borderRadius: 14,
                          border: '1px solid rgba(255,255,255,0.1)',
                        }}
                      >
                        <span style={{
                          width: 24,
                          height: 24,
                          borderRadius: 8,
                          background: 'rgba(34, 197, 94, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                          color: '#4ADE80',
                          fontSize: 12,
                          fontWeight: 700,
                        }}>
                          ✓
                        </span>
                        <div>
                          <div style={{ fontWeight: 700, fontSize: 14, color: '#FFFFFF', marginBottom: 4 }}>
                            {item.title}
                          </div>
                          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.45 }}>
                            {item.desc}
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </motion.div>
            </div>
            
            {/* ═══ MINI-BANDEAU DE VÉRITÉ ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: 'rgba(249, 115, 22, 0.06)',
                border: '1px solid rgba(249, 115, 22, 0.15)',
                borderRadius: 22,
                padding: 'clamp(24px, 4vw, 32px)',
                textAlign: 'center',
                marginBottom: 40,
              }}
            >
              <h4 style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800,
                fontSize: 'clamp(20px, 2.5vw, 26px)',
                color: '#0F2A44',
                marginBottom: 12,
              }}>
                Ce n'est pas magique.<br />
                <span style={{ color: '#F97316' }}>C'est une meilleure façon de travailler.</span>
              </h4>
              <p style={{
                fontSize: 'clamp(14px, 1.5vw, 16px)',
                color: '#64748B',
                margin: 0,
                maxWidth: 700,
                marginLeft: 'auto',
                marginRight: 'auto',
                lineHeight: 1.55,
              }}>
                Abracada t'aide à passer d'une organisation dispersée à un espace structuré, connecté et évolutif.
              </p>
            </motion.div>
            
            {/* ═══ MICRO-CARTES BAS — 4 POINTS DE DIFFÉRENCE ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 18,
            }} className="difference-cards-grid">
              {[
                { before: 'Avant : tu subis', after: 'Après : tu structures', iconBg: '#DBEAFE', iconColor: '#2563EB', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg> },
                { before: 'Avant : tu oublies', after: 'Après : tu suis', iconBg: '#DCFCE7', iconColor: '#16A34A', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg> },
                { before: 'Avant : tu cherches', after: 'Après : tu retrouves', iconBg: '#FFEDD5', iconColor: '#EA580C', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg> },
                { before: 'Avant : tu portes tout', after: 'Après : tu pilotes mieux', iconBg: '#EDE9FE', iconColor: '#7C3AED', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg> },
              ].map((card, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  style={{
                    background: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    borderRadius: 18,
                    padding: '24px 20px',
                    textAlign: 'center',
                    boxShadow: '0 4px 20px rgba(15, 42, 68, 0.04)',
                    transition: 'all 0.2s ease',
                  }}
                  whileHover={{ y: -3, borderColor: 'rgba(249, 115, 22, 0.25)' }}
                >
                  <div style={{
                    width: 48,
                    height: 48,
                    borderRadius: 14,
                    background: card.iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 16px',
                    color: card.iconColor,
                  }}>
                    {card.icon}
                  </div>
                  <div style={{
                    fontSize: 13,
                    color: '#94A3B8',
                    fontWeight: 500,
                    marginBottom: 6,
                    textDecoration: 'line-through',
                  }}>
                    {card.before}
                  </div>
                  <div style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontWeight: 700,
                    fontSize: 15,
                    color: '#0F2A44',
                  }}>
                    {card.after}
                  </div>
                </motion.div>
              ))}
            </div>
            
          </div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            BLOC 8 — LES FORMULES (Conversion principale)
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: '#FFFFFF',
          padding: 'clamp(70px, 10vw, 120px) clamp(20px, 5vw, 40px)',
        }}>
          <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Badge haut */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: 'rgba(249, 115, 22, 0.10)',
                border: '1px solid rgba(249, 115, 22, 0.2)',
                color: '#F97316',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 700,
              }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Formules AbracadaPro
              </span>
            </div>
            
            {/* Titre principal */}
            <h2 style={{
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(32px, 5vw, 58px)',
              lineHeight: 1.05,
              marginBottom: 24,
              color: '#0F2A44',
              maxWidth: 950,
              margin: '0 auto 24px',
            }}>
              Commence avec un assistant.<br />
              <span style={{ color: '#F97316' }}>Fais grandir ton équipe IA.</span>
            </h2>
            
            {/* Sous-texte */}
            <p style={{
              textAlign: 'center',
              maxWidth: 880,
              margin: '0 auto 48px',
              fontSize: 'clamp(16px, 2vw, 20px)',
              lineHeight: 1.6,
              color: '#475569',
            }}>
              Chaque formule inclut l'écosystème AbracadaPro : ton site, ta boutique, ton Cockpit et ton niveau d'assistance IA. Tu démarres simplement, puis tu ajoutes de la puissance quand ton activité en a besoin.
            </p>
            
            {/* ═══ BANDEAU OFFRE LANCEMENT ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: 'linear-gradient(135deg, #0B1F3A 0%, #1E3A5F 100%)',
                borderRadius: 24,
                padding: 'clamp(20px, 3vw, 28px) clamp(24px, 4vw, 36px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 24,
                marginBottom: 36,
                position: 'relative',
                overflow: 'hidden',
              }}
              className="launch-banner"
            >
              {/* Glow orange subtil */}
              <div style={{
                position: 'absolute',
                top: '50%',
                right: '15%',
                width: 200,
                height: 200,
                background: 'radial-gradient(circle, rgba(249, 115, 22, 0.15) 0%, transparent 70%)',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }} />
              
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 'clamp(18px, 2.5vw, 24px)',
                  color: '#FFFFFF',
                  marginBottom: 6,
                }}>
                  Offre lancement — <span style={{ color: '#F97316' }}>tarifs réservés aux Membres Fondateurs</span>
                </div>
                <p style={{
                  fontSize: 'clamp(13px, 1.5vw, 15px)',
                  color: 'rgba(255,255,255,0.7)',
                  margin: 0,
                }}>
                  Prix affichés pour un abonnement annuel. Tout est inclus selon la formule choisie.
                </p>
              </div>
              
              <span style={{
                background: 'rgba(255, 255, 255, 0.12)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                padding: '10px 20px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 600,
                color: '#FFFFFF',
                whiteSpace: 'nowrap',
                position: 'relative',
                zIndex: 1,
              }}>
                Abonnement annuel
              </span>
            </motion.div>
            
            {/* ═══ CARTES TARIFS — 3 COLONNES ═══ */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 28,
              alignItems: 'stretch',
              marginBottom: 56,
            }} className="pricing-cards-grid">
              
              {/* CARTE 1 — PRO */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0 }}
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  borderRadius: 28,
                  padding: 34,
                  boxShadow: '0 12px 40px rgba(15, 42, 68, 0.06)',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.2s ease',
                }}
                whileHover={{ y: -4, boxShadow: '0 20px 50px rgba(15, 42, 68, 0.10)' }}
              >
                <span style={{
                  background: '#DBEAFE',
                  color: '#2563EB',
                  padding: '6px 14px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                  alignSelf: 'flex-start',
                  marginBottom: 16,
                }}>
                  Pour démarrer
                </span>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 32,
                  color: '#0F2A44',
                  marginBottom: 8,
                }}>
                  Pro
                </h3>
                <p style={{ fontSize: 15, color: '#64748B', marginBottom: 20 }}>
                  Ton Super Assistant IA
                </p>
                
                <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.55, marginBottom: 24 }}>
                  L'essentiel pour commencer avec un assistant intelligent intégré à ton Cockpit.
                </p>
                
                {/* Prix */}
                <div style={{ marginBottom: 24 }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                    <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 42, color: '#0F2A44' }}>50€</span>
                    <span style={{ fontSize: 16, color: '#64748B' }}>/ mois</span>
                  </div>
                  <p style={{ fontSize: 13, color: '#64748B', margin: '6px 0' }}>soit 600€ / an — offre lancement</p>
                  <p style={{ fontSize: 12, color: '#94A3B8', margin: 0 }}>Puis 75€ / mois en annuel</p>
                </div>
                
                {/* Inclusions */}
                <div style={{ flex: 1, marginBottom: 24 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {['Super Assistant IA', 'Notes vocales', 'Cockpit AbracadaPro', 'Site internet inclus', 'Boutique incluse', 'Aide à l\'organisation', 'Réponses et actions préparées', 'Support'].map((item, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#334155' }}>
                        <span style={{ color: '#16A34A', fontWeight: 700 }}>✓</span>
                        {item}
                      </div>
                    ))}
                  </div>
                  <p style={{ fontSize: 12, color: '#94A3B8', fontStyle: 'italic', marginTop: 16 }}>
                    Pas d'agents IA spécialisés dans cette formule.
                  </p>
                </div>
                
                {/* CTA */}
                <button style={{
                  background: 'transparent',
                  border: '2px solid #0F2A44',
                  borderRadius: 14,
                  padding: '16px 24px',
                  color: '#0F2A44',
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  width: '100%',
                }}>
                  Choisir Pro
                </button>
              </motion.div>
              
              {/* CARTE 2 — BUSINESS (Mise en avant) */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                style={{
                  background: '#FFFFFF',
                  border: '2px solid #F97316',
                  borderRadius: 30,
                  padding: 38,
                  boxShadow: '0 20px 60px rgba(249, 115, 22, 0.15)',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                  transform: 'scale(1.03)',
                  transition: 'all 0.2s ease',
                }}
                whileHover={{ y: -4, boxShadow: '0 28px 70px rgba(249, 115, 22, 0.20)' }}
              >
                {/* Badge populaire */}
                <div style={{
                  position: 'absolute',
                  top: -14,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                  color: '#FFFFFF',
                  padding: '8px 20px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                  boxShadow: '0 4px 15px rgba(249, 115, 22, 0.35)',
                }}>
                  Le plus équilibré
                </div>
                
                <span style={{
                  background: '#FFEDD5',
                  color: '#EA580C',
                  padding: '6px 14px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                  alignSelf: 'flex-start',
                  marginBottom: 16,
                  marginTop: 8,
                }}>
                  Recommandé
                </span>
                
                <h3 style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800,
                  fontSize: 32,
                  color: '#0F2A44',
                  marginBottom: 8,
                }}>
                  Business
                </h3>
                <p style={{ fontSize: 15, color: '#64748B', marginBottom: 20 }}>
                  Super Assistant + <span style={{ color: '#F97316', fontWeight: 700 }}>4 agents IA</span>
                </p>
                
                <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.55, marginBottom: 24 }}>
                  Pour structurer les missions essentielles : commercial, administratif, service client et organisation.
                </p>
                
                {/* Prix */}
                <div style={{ marginBottom: 24 }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                    <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 42, color: '#F97316' }}>75€</span>
                    <span style={{ fontSize: 16, color: '#64748B' }}>/ mois</span>
                  </div>
                  <p style={{ fontSize: 13, color: '#64748B', margin: '6px 0' }}>soit 900€ / an — offre lancement</p>
                  <p style={{ fontSize: 12, color: '#94A3B8', margin: 0 }}>Puis 100€ / mois en annuel</p>
                </div>
                
                {/* Inclusions */}
                <div style={{ flex: 1, marginBottom: 24 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {[
                      { text: 'Tout Pro inclus', bold: true },
                      { text: 'Super Assistant IA' },
                      { text: '+ 4 agents IA spécialisés', highlight: true },
                      { text: 'Agent Commercial', indent: true },
                      { text: 'Agent Administratif', indent: true },
                      { text: 'Agent Service Client', indent: true },
                      { text: 'Agent Organisation / Chantier', indent: true },
                      { text: 'Automatisations et suivis renforcés' },
                      { text: 'Support prioritaire' },
                    ].map((item, i) => (
                      <div key={i} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 10, 
                        fontSize: 14, 
                        color: item.highlight ? '#F97316' : '#334155',
                        fontWeight: item.bold || item.highlight ? 700 : 400,
                        marginLeft: item.indent ? 20 : 0,
                      }}>
                        <span style={{ color: '#16A34A', fontWeight: 700 }}>✓</span>
                        {item.text}
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* CTA */}
                <button style={{
                  background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
                  border: 'none',
                  borderRadius: 14,
                  padding: '18px 24px',
                  color: '#FFFFFF',
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  width: '100%',
                  boxShadow: '0 6px 20px rgba(34, 197, 94, 0.3)',
                }}>
                  Choisir Business
                </button>
              </motion.div>
              
              {/* CARTE 3 — PREMIUM */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                style={{
                  background: 'linear-gradient(135deg, #0B1F3A 0%, #1E3A5F 50%, #0F2A44 100%)',
                  border: '1px solid rgba(249, 115, 22, 0.3)',
                  borderRadius: 28,
                  padding: 34,
                  boxShadow: '0 20px 60px rgba(15, 42, 68, 0.25)',
                  display: 'flex',
                  flexDirection: 'column',
                  color: '#FFFFFF',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.2s ease',
                }}
                whileHover={{ y: -4, boxShadow: '0 28px 70px rgba(15, 42, 68, 0.35)' }}
              >
                {/* Grille subtile */}
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  backgroundImage: `
                    linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
                  `,
                  backgroundSize: '25px 25px',
                  pointerEvents: 'none',
                }} />
                
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <span style={{
                    background: 'rgba(249, 115, 22, 0.2)',
                    border: '1px solid rgba(249, 115, 22, 0.4)',
                    color: '#F97316',
                    padding: '6px 14px',
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                    display: 'inline-block',
                    marginBottom: 16,
                  }}>
                    ⭐ Dream Team complète
                  </span>
                  
                  <h3 style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontWeight: 800,
                    fontSize: 32,
                    color: '#FFFFFF',
                    marginBottom: 8,
                  }}>
                    Premium
                  </h3>
                  <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.7)', marginBottom: 20 }}>
                    Super Assistant + <span style={{ color: '#F97316', fontWeight: 700 }}>12 agents IA</span>
                  </p>
                  
                  <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', lineHeight: 1.55, marginBottom: 24 }}>
                    Pour piloter une organisation complète avec une équipe IA spécialisée autour de ton activité.
                  </p>
                  
                  {/* Prix */}
                  <div style={{ marginBottom: 24 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                      <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 42, color: '#F97316' }}>100€</span>
                      <span style={{ fontSize: 16, color: 'rgba(255,255,255,0.7)' }}>/ mois</span>
                    </div>
                    <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', margin: '6px 0' }}>soit 1 200€ / an — offre lancement</p>
                    <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', margin: 0 }}>Puis 150€ / mois en annuel</p>
                  </div>
                  
                  {/* Inclusions */}
                  <div style={{ flex: 1, marginBottom: 24 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#FFFFFF', fontWeight: 700 }}>
                        <span style={{ color: '#4ADE80' }}>✓</span>
                        Tout Business inclus
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#F97316', fontWeight: 700 }}>
                        <span style={{ color: '#4ADE80' }}>✓</span>
                        + 12 agents IA spécialisés
                      </div>
                      <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gap: '8px 16px',
                        marginTop: 8,
                        marginLeft: 28,
                      }}>
                        {['Commercial', 'Administratif', 'Service client', 'Chantier', 'Marketing', 'Community', 'Webmaster', 'Créatif', 'Réputation', 'Financier', 'Juridique', 'Logistique'].map((agent, i) => (
                          <span key={i} style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>
                            • {agent}
                          </span>
                        ))}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#FFFFFF', marginTop: 8 }}>
                        <span style={{ color: '#4ADE80' }}>✓</span>
                        Priorité absolue
                      </div>
                    </div>
                    <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', fontStyle: 'italic', marginTop: 16 }}>
                      Le conseil juridique ne remplace pas un professionnel du droit.
                    </p>
                  </div>
                  
                  {/* CTA */}
                  <button style={{
                    background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                    border: 'none',
                    borderRadius: 14,
                    padding: '18px 24px',
                    color: '#FFFFFF',
                    fontSize: 16,
                    fontWeight: 700,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    width: '100%',
                    boxShadow: '0 6px 20px rgba(249, 115, 22, 0.35)',
                  }}>
                    Choisir Premium
                  </button>
                </div>
              </motion.div>
            </div>
            
            {/* ═══ COMPARATIF RAPIDE ═══ */}
            <div style={{ marginBottom: 40 }}>
              <h4 style={{
                textAlign: 'center',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: 20,
                color: '#0F2A44',
                marginBottom: 24,
              }}>
                Ce qui change entre les formules
              </h4>
              
              <div style={{
                background: '#FFFFFF',
                border: '1px solid #E5E7EB',
                borderRadius: 24,
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(15, 42, 68, 0.04)',
              }}>
                {/* Header */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '2fr 1fr 1fr 1fr',
                  background: '#F8FAFC',
                  borderBottom: '1px solid #E5E7EB',
                }} className="comparison-table-header">
                  <div style={{ padding: '16px 24px', fontWeight: 700, fontSize: 14, color: '#64748B' }}></div>
                  <div style={{ padding: '16px 20px', fontWeight: 700, fontSize: 14, color: '#2563EB', textAlign: 'center' }}>Pro</div>
                  <div style={{ padding: '16px 20px', fontWeight: 700, fontSize: 14, color: '#F97316', textAlign: 'center', background: 'rgba(249, 115, 22, 0.05)' }}>Business</div>
                  <div style={{ padding: '16px 20px', fontWeight: 700, fontSize: 14, color: '#0F2A44', textAlign: 'center', background: 'rgba(15, 42, 68, 0.04)' }}>Premium</div>
                </div>
                
                {/* Rows */}
                {[
                  { label: 'Super Assistant IA', pro: true, business: true, premium: true },
                  { label: 'Notes vocales', pro: true, business: true, premium: true },
                  { label: 'Cockpit', pro: true, business: true, premium: true },
                  { label: 'Site internet + boutique', pro: true, business: true, premium: true },
                  { label: 'Agents IA spécialisés', pro: 'Non', business: '4 agents', premium: '12 agents' },
                  { label: 'Niveau d\'automatisation', pro: 'Assistant', business: 'Renforcé', premium: 'Avancé' },
                  { label: 'Support', pro: 'Standard', business: 'Prioritaire', premium: 'Prioritaire' },
                ].map((row, i) => (
                  <div key={i} style={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr',
                    borderBottom: i < 6 ? '1px solid #F1F5F9' : 'none',
                  }} className="comparison-table-row">
                    <div style={{ padding: '14px 24px', fontSize: 14, color: '#334155', fontWeight: 500 }}>{row.label}</div>
                    <div style={{ padding: '14px 20px', fontSize: 14, textAlign: 'center', color: row.pro === true ? '#16A34A' : row.pro === 'Non' ? '#94A3B8' : '#334155' }}>
                      {row.pro === true ? '✓' : row.pro}
                    </div>
                    <div style={{ padding: '14px 20px', fontSize: 14, textAlign: 'center', background: 'rgba(249, 115, 22, 0.03)', color: row.business === true ? '#16A34A' : '#F97316', fontWeight: typeof row.business === 'string' ? 600 : 400 }}>
                      {row.business === true ? '✓' : row.business}
                    </div>
                    <div style={{ padding: '14px 20px', fontSize: 14, textAlign: 'center', background: 'rgba(15, 42, 68, 0.02)', color: row.premium === true ? '#16A34A' : '#0F2A44', fontWeight: typeof row.premium === 'string' ? 600 : 400 }}>
                      {row.premium === true ? '✓' : row.premium}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* ═══ BANDEAU RASSURANCE ═══ */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                background: 'rgba(249, 115, 22, 0.06)',
                border: '1px solid rgba(249, 115, 22, 0.15)',
                borderRadius: 22,
                padding: 'clamp(24px, 4vw, 32px)',
                textAlign: 'center',
              }}
            >
              <h4 style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800,
                fontSize: 'clamp(20px, 2.5vw, 26px)',
                color: '#0F2A44',
                marginBottom: 12,
              }}>
                Tu peux <span style={{ color: '#F97316' }}>commencer simple.</span>
              </h4>
              <p style={{
                fontSize: 'clamp(14px, 1.5vw, 16px)',
                color: '#64748B',
                margin: 0,
                maxWidth: 700,
                marginLeft: 'auto',
                marginRight: 'auto',
                lineHeight: 1.55,
              }}>
                Le Super Assistant est déjà une vraie aide au quotidien. Les agents IA viennent ensuite quand tu veux renforcer ton organisation.
              </p>
            </motion.div>
            
          </div>
        </section>


        {/* ═══════════════════════════════════════════════════════════════════
            BLOC 9 — CTA FINAL DE CONVERSION
        ═══════════════════════════════════════════════════════════════════ */}
        <section style={{
          background: 'linear-gradient(135deg, #0B1F3A 0%, #1E3A5F 50%, #0F2A44 100%)',
          padding: 'clamp(80px, 12vw, 120px) clamp(20px, 5vw, 40px)',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Grille subtile en fond */}
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `
              linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px',
            pointerEvents: 'none',
          }} />
          
          {/* Glow orange subtil */}
          <div style={{
            position: 'absolute',
            top: '10%',
            right: '15%',
            width: 400,
            height: 400,
            background: 'radial-gradient(circle, rgba(249, 115, 22, 0.12) 0%, transparent 70%)',
            pointerEvents: 'none',
          }} />
          <div style={{
            position: 'absolute',
            bottom: '20%',
            left: '10%',
            width: 300,
            height: 300,
            background: 'radial-gradient(circle, rgba(249, 115, 22, 0.08) 0%, transparent 70%)',
            pointerEvents: 'none',
          }} />
          
          <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>
            
            {/* Badge haut */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{ textAlign: 'center', marginBottom: 28 }}
            >
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 10,
                background: 'rgba(255, 255, 255, 0.10)',
                border: '1px solid rgba(255, 255, 255, 0.18)',
                color: '#FFFFFF',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 14,
                fontWeight: 700,
              }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#F97316' }} />
                Prêt à déléguer autrement ?
              </span>
            </motion.div>
            
            {/* Titre principal */}
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              style={{
                textAlign: 'center',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800,
                fontSize: 'clamp(36px, 6vw, 68px)',
                lineHeight: 1.05,
                marginBottom: 28,
                color: '#FFFFFF',
                maxWidth: 980,
                margin: '0 auto 28px',
              }}
            >
              Commence avec ton Super Assistant.<br />
              <span style={{ color: '#F97316' }}>Fais grandir ton équipe quand tu veux.</span>
            </motion.h2>
            
            {/* Sous-texte */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              style={{
                textAlign: 'center',
                maxWidth: 820,
                margin: '0 auto 44px',
                fontSize: 'clamp(16px, 2vw, 20px)',
                lineHeight: 1.6,
                color: 'rgba(255, 255, 255, 0.82)',
              }}
            >
              Tu n'as pas besoin de tout changer.<br />
              Tu démarres simplement dans ton Cockpit, avec un assistant IA qui t'aide au quotidien.<br />
              Puis tu ajoutes des agents spécialisés quand ton activité demande plus de puissance.
            </motion.p>
            
            {/* CTA PRINCIPAUX */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 16,
                marginBottom: 40,
              }}
              className="final-cta-buttons"
            >
              <button style={{
                background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
                border: 'none',
                borderRadius: 14,
                padding: '18px 30px',
                color: '#FFFFFF',
                fontSize: 17,
                fontWeight: 800,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 8px 25px rgba(34, 197, 94, 0.35)',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}>
                Devenir Membre Fondateur
                <span style={{ fontSize: 18 }}>→</span>
              </button>
              
              <button style={{
                background: 'transparent',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: 14,
                padding: '18px 30px',
                color: '#FFFFFF',
                fontSize: 17,
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}>
                Voir les formules
              </button>
            </motion.div>
            
            {/* MINI-PILIERS DE RASSURANCE */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 14,
                marginBottom: 46,
                flexWrap: 'wrap',
              }}
              className="reassurance-capsules"
            >
              {[
                { icon: '✓', text: 'Super Assistant inclus' },
                { icon: '🎤', text: 'Notes vocales' },
                { icon: '🎯', text: 'Cockpit + boutique' },
                { icon: '⚡', text: 'Agents selon formule' },
              ].map((item, i) => (
                <span key={i} style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  background: 'rgba(255, 255, 255, 0.08)',
                  border: '1px solid rgba(255, 255, 255, 0.14)',
                  color: '#FFFFFF',
                  padding: '12px 18px',
                  borderRadius: 999,
                  fontSize: 15,
                  fontWeight: 600,
                  transition: 'all 0.2s ease',
                }}>
                  <span style={{ color: '#F97316' }}>{item.icon}</span>
                  {item.text}
                </span>
              ))}
            </motion.div>
            
            {/* CARTE RASSURANCE BASSE */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 }}
              style={{
                background: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                borderRadius: 24,
                padding: 'clamp(24px, 4vw, 34px)',
                maxWidth: 900,
                margin: '0 auto',
                backdropFilter: 'blur(8px)',
                textAlign: 'center',
              }}
            >
              <p style={{
                fontSize: 'clamp(18px, 2.5vw, 22px)',
                fontWeight: 700,
                color: '#FFFFFF',
                marginBottom: 12,
                lineHeight: 1.4,
              }}>
                Tu restes maître. <span style={{ color: '#F97316' }}>L'IA t'aide à mieux organiser, préparer et suivre ton activité.</span>
              </p>
              <p style={{
                fontSize: 'clamp(14px, 1.5vw, 16px)',
                color: 'rgba(255, 255, 255, 0.75)',
                margin: 0,
                lineHeight: 1.5,
              }}>
                AbracadaPro n'est pas un outil de plus : c'est ton espace professionnel rendu plus intelligent.
              </p>
            </motion.div>
            
            {/* MICRO-LIGNE FINALE */}
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6 }}
              style={{
                textAlign: 'center',
                color: 'rgba(255, 255, 255, 0.55)',
                fontSize: 14,
                marginTop: 28,
              }}
            >
              Offre lancement réservée aux premiers membres — abonnement annuel.
            </motion.p>
            
          </div>
        </section>


      </div>
      
      
    </ImmersiveEspaceProWrapper>
  );
}

// END OF FILE - PLACEHOLDER FOR NEW BLOCKS
